import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../Layout/Sidebar";
import Topbar from "../Layout/Topbar";
import { ToastContainer, toast } from "react-toastify";
import { Breadcrumb } from "react-bootstrap";
import Loader from "../Common/Loader";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import {
  DateRangePicker,
  createStaticRanges,
  Calendar,
} from "react-date-range";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
  LinearProgress,
  Avatar,
  IconButton,
  Tooltip,
  MenuItem,
  DialogActions,
  Select,
  InputLabel,
  DialogContent,
  FormControl,
  DialogTitle,
  Dialog,
  ListItemText,
  Checkbox,
  Chip,
  Switch,
  FormControlLabel,
  OutlinedInput,
  Paper,
  Divider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import "./StaffShift.css";
import { apiRequest } from "../../services/api";
import { encryptData } from "../Common/encryptionUtils";
import { use } from "react";
import Shimmer from "../Common/Shimmer";
import {
  addDays,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
} from "date-fns";
import { AccessLog } from "../../Utils/AccessLog";

const StaffShift = () => {
  const [startDate, setStartDate] = useState(moment().startOf("week"));
  const [shiftDetails, setShiftDetails] = useState([]);
  const [allstaffIds, setAllstaffIds] = useState([]);
  const [publishStatus, setPublishStatus] = useState(false);
  const [lockStatus, setLockStatus] = useState(false);

  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [addShiftOpen, setAddShiftOpen] = useState(false);
  const [editShiftOpen, setEditShiftOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedStaff, setSelectedStaff] = useState("");
  const [selectedAddStaff, setSelectedAddStaff] = useState([]);
  const [selectedStaffList, setSelectedStaffList] = useState([]);

  const [selectedDateStr, setSelectedDateStr] = useState("");
  const [selectedShift, setSelectedShift] = useState([]);
  const [selectedShiftIds, setSelectedShiftIds] = useState([]);
  const [previousShifts, setPreviousShifts] = useState([]);
  const [workShiftTemplates, setWorkShiftTemplates] = useState([]);
  // Download dialog and options
  const [downloadDialogOpen, setDownloadDialogOpen] = useState(false);
  const [exportIncludeTimes, setExportIncludeTimes] = useState(false);
  const downloadToday = moment();
  const [downloadMonth, setDownloadMonth] = useState(downloadToday.month()); // 0-based
  const [downloadYear, setDownloadYear] = useState(downloadToday.year());
  // CSV import preview/import state
  const [previewOpen, setPreviewOpen] = useState(false);
  const [parsedItems, setParsedItems] = useState([]);
  const [importInProgress, setImportInProgress] = useState(false);
  const [importProgress, setImportProgress] = useState({ total: 0, success: 0, failed: 0 });
  const [importResults, setImportResults] = useState([]);
  const [infoRowsCount, setInfoRowsCount] = useState(0);
  const [infoColumnsCount, setInfoColumnsCount] = useState(0);
  const authToken = localStorage.getItem("authToken");
  const selectedTopBarPremises = JSON.parse(
    localStorage.getItem("selectedTopBarPremises")
  );

  const userDummyImage =
    "https://businesstime.app/business-i_backend_uat/public/uploads/dummyuser.png";

  const handleNextWeek = () => {
    setStartDate((prev) => moment(prev).add(7, "days"));
  };

  const handlePrevWeek = () => {
    setStartDate((prev) => moment(prev).subtract(7, "days"));
  };

  const getWeekDates = () => {
    return Array.from({ length: 7 }).map((_, i) =>
      moment(startDate).add(i, "days")
    );
  };

  const handleAddShift = (userData, date) => {
    // alert(`Add shift for ${userName} on ${date}`);
    console.log("userData-->", userData);
    setSelectedUser(userData?.user_id);
    setSelectedStaff(userData?.staff_id);
    const formattedDate = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
    console.log("selectedDateStr-->", formattedDate);
    setSelectedDateStr(formattedDate);
    setAddShiftOpen(true);
  };

  const handleEditShift = (user, dateStr) => {
    // Find the shift entry matching the clicked date
    const dateShiftEntry = user.results.find((entry) => entry.date === dateStr);
    setPreviousShifts(dateShiftEntry);
    console.log("dateShiftEntry--->", dateShiftEntry);

    // If found, extract the shift template IDs
    const shiftIds = dateShiftEntry
      ? dateShiftEntry.slots.map((slot) => slot.user_shift_templates_id)
      : [];

    console.log("dsdsd--->", user);
    // Set state
    setSelectedShiftIds(shiftIds);
    setSelectedUser(user?.user_id);
    setSelectedStaff(user?.staff_id);
    setSelectedDateStr(dateStr);

    // Open the dialog
    setEditShiftOpen(true);
  };

  console.log("selectedShift--->", selectedShift);

  const [selectedPremise, setSelectedPremise] = useState(
    JSON.parse(localStorage.getItem("selectedTopBarPremises"))
  );

  const navigate = useNavigate();

  const handlePremiseSelect = (selected) => {
    if (selected?.value) {
      setSelectedPremise(selected);
      if (selected?.scheduler_feature == "false") {
        navigate("/dashboard");
      } else {
        fetchShiftTemplates(selected?.value);
        fetchStaffNotInCalender(selected?.value);
        initialFetchShiftDetails(selected?.value);
      }
    }
  };

  const handleSaveShift = () => {
    setAddShiftOpen(false);
    addWorkShift();
  };

  const handleUpdateShift = () => {
    const selectedShiftObjects = workShiftTemplates.filter((shift) =>
      selectedShiftIds.includes(shift.user_shift_templates_id)
    );

    console.log("Selected shift data:", selectedShiftObjects); // 👉 you get full objects here

    const slotMap = new Map();
    previousShifts.slots.forEach((slot) => {
      slotMap.set(slot.user_shift_templates_id, slot);
    });

    const updateWorkShiftPayload = [];

    selectedShiftObjects.forEach((template) => {
      const matchedSlot = slotMap.get(template.user_shift_templates_id);

      if (matchedSlot) {
        // Template exists in slots => "accepted"
        updateWorkShiftPayload.push({
          user_shift_schedule_times_id: encryptData(
            matchedSlot.user_shift_schedule_times_id?.toString()
          ),
          user_shift_templates_id: encryptData(
            template.user_shift_templates_id?.toString()
          ),
          shift_date: encryptData(previousShifts.date?.toString()),
          staff_accepted_status: encryptData("accepted"),
        });

        // Remove from slotMap to track remaining (for "rejected")
        slotMap.delete(template.user_shift_templates_id);
      } else {
        // Template does not exist in slots => "new"
        updateWorkShiftPayload.push({
          user_shift_schedule_times_id: encryptData(""),
          user_shift_templates_id: encryptData(
            template.user_shift_templates_id?.toString()
          ),
          shift_date: encryptData(previousShifts.date?.toString()),
          staff_accepted_status: encryptData("accepted"),
        });
      }
    });

    // Remaining slots in slotMap are "rejected"
    for (const slot of slotMap.values()) {
      updateWorkShiftPayload.push({
        user_shift_schedule_times_id: encryptData(
          slot.user_shift_schedule_times_id?.toString()
        ),
        user_shift_templates_id: encryptData(
          slot.user_shift_templates_id?.toString()
        ),
        shift_date: encryptData(previousShifts.date?.toString()),
        staff_accepted_status: encryptData("rejected"),
      });
    }

    console.log("finalResult--->", updateWorkShiftPayload);

    if (updateWorkShiftPayload.length > 0) {
      updateWorkShift(updateWorkShiftPayload);
    }

    // You can now send this data to the backend or store it in state
    setSelectedShift(selectedShiftObjects);
    setEditShiftOpen(false);
  };

  const handleRemoveShift = (userName, date, shiftIndex) => {
    console.log(`Remove shift #${shiftIndex} for ${userName} on ${date}`);
    // Remove logic goes here
  };

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null); // { user, date, index }

  const handleOpenDeleteConfirm = (user, date, index) => {
    setDeleteTarget({ user, date, index });
    setDeleteDialogOpen(true);
  };

  const handleConfirmDelete = () => {
    const { user, date, index } = deleteTarget;
    // Your actual delete logic here
    console.log(`Deleted shift ${index} for ${user} on ${date}`);
    setDeleteDialogOpen(false);
    setDeleteTarget(null);
  };

  console.log("selectedShiftIds--->", selectedShiftIds);

  const fetchShiftDetails = async () => {
    // setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const startDate1 = startDate.format("YYYY-MM-DD");
      const endDate = moment(startDate).add(6, "days").format("YYYY-MM-DD");

      console.log("startDate-->", startDate);

      const payload = {
        premise_id: encryptData(selectedTopBarPremises?.value?.toString()),
        start_date: encryptData(startDate1?.toString()),
        end_date: encryptData(endDate?.toString()),
      };
      const apiResponse = await apiRequest(
        "/api/user/getSchedulerDetailsAllUser",
        "POST",
        payload,
        headers
      );

      if (
        apiResponse?.data?.status_code === 200 &&
        apiResponse?.data?.data?.shift_details
      ) {
        if (apiResponse?.data?.data?.shift_details?.length > 0) {
          const allUserShiftDetails = apiResponse?.data?.data?.shift_details;
          console.log("allUserShiftDetails-->", allUserShiftDetails);
          setShiftDetails(allUserShiftDetails);
          const staffIds = allUserShiftDetails.map((item) => item.staff_id);
          setAllstaffIds(staffIds);
          setPublishStatus(apiResponse?.data?.data?.is_publish);
          setLockStatus(apiResponse?.data?.data?.is_locked);
        } else {
          console.log("allUserShiftDetails111-->");
          setShiftDetails([]);
        }
      } else {
        const errorMessage =
          apiResponse?.data?.message || "Something went wrong.";
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      console.error("Error fetching shift templates", error);
      toast.error("Failed to fetch shift templates");
    } finally {
      // setLoading(false);
    }
  };

  const initialFetchShiftDetails = async (premiseId) => {
    setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const startDate1 = startDate.format("YYYY-MM-DD");
      const endDate = moment(startDate).add(6, "days").format("YYYY-MM-DD");

      console.log("startDate-->", startDate);

      const payload = {
        premise_id: encryptData(premiseId?.toString()),
        start_date: encryptData(startDate1?.toString()),
        end_date: encryptData(endDate?.toString()),
      };
      const apiResponse = await apiRequest(
        "/api/user/getSchedulerDetailsAllUser",
        "POST",
        payload,
        headers
      );

      if (
        apiResponse?.data?.status_code === 200 &&
        apiResponse?.data?.data?.shift_details
      ) {
        if (apiResponse?.data?.data?.shift_details?.length > 0) {
          const allUserShiftDetails = apiResponse?.data?.data?.shift_details;
          console.log("allUserShiftDetails-->", allUserShiftDetails);
          setShiftDetails(allUserShiftDetails);
          const staffIds = allUserShiftDetails.map((item) => item.staff_id);
          setAllstaffIds(staffIds);
          setPublishStatus(apiResponse?.data?.data?.is_publish);
          setLockStatus(apiResponse?.data?.data?.is_locked);
        } else {
          setShiftDetails([]);
        }
      } else {
        const errorMessage =
          apiResponse?.data?.message || "Something went wrong.";
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      console.error("Error fetching shift templates", error);
      toast.error("Failed to fetch shift templates");
    } finally {
      setLoading(false);
    }
  };

  const fetchShiftTemplates = async (premise_id) => {
    // setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const apiResponse = await apiRequest(
        `api/user/getUserShiftTemplatesByPremiseId?premise_id=${encryptData(
          premise_id?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (
        apiResponse?.data?.status_code === 200 &&
        apiResponse?.data?.data?.user_shift_templates_details
      ) {
        if (apiResponse?.data?.data?.user_shift_templates_details?.length > 0) {
          const mappedShifts =
            apiResponse?.data?.data?.user_shift_templates_details.map(
              (shift) => {
                const formattedStartTime = moment(
                  shift.start_time,
                  "HH:mm:ss"
                ).format("hh:mm A");
                const formattedEndTime = moment(
                  shift.end_time,
                  "HH:mm:ss"
                ).format("hh:mm A");

                return {
                  ...shift,
                  start_time: formattedStartTime,
                  end_time: formattedEndTime,
                };
              }
            );
          setWorkShiftTemplates(mappedShifts);
        } else {
          setWorkShiftTemplates([]);
        }
      } else {
        setWorkShiftTemplates([]);
        const errorMessage =
          apiResponse?.data?.message || "Something went wrong.";
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      console.error("Error fetching shift templates", error);
      toast.error("Failed to fetch shift templates");
    } finally {
      // setLoading(false);
    }
  };

  const addWorkShift = async () => {
    // setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };

      const payload = {
        premise_id: encryptData(selectedTopBarPremises?.value?.toString()),
        user_id: encryptData(selectedUser?.toString()),
        shift_start_date: encryptData(selectedDateStr?.toString()),
        shift_end_date: encryptData(selectedDateStr?.toString()),
        ArrayOfUser_shift_templates_id: selectedShiftIds,
      };

      const apiResponse = await apiRequest(
        "/api/user/addSchedulerDetailsToUserId",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        await fetchShiftDetails();
        toast.success(apiResponse?.data?.message, {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        const errorMessage =
          apiResponse?.data?.message || "Something went wrong.";
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      console.error("Error fetching shift templates", error);
      toast.error("Failed to fetch shift templates");
    } finally {
      // setLoading(false);
      setSelectedShift([]);
      setSelectedShiftIds([]);
      setSelectedUser("");
      setSelectedStaff("");
    }
  };

  const updateWorkShift = async (updateWorkShiftPayload) => {
    // setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };

      const payload = {
        premise_id: encryptData(selectedTopBarPremises?.value?.toString()),
        staff_id: encryptData(selectedStaff?.toString()),
        user_id: encryptData(selectedUser?.toString()),
        arrayofacceptrejectshift: updateWorkShiftPayload,
      };

      const apiResponse = await apiRequest(
        "/api/user/acceptRejectShiftByUser",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        await fetchShiftDetails();
        toast.success("Work Shift Updated successfully", {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        const errorMessage =
          apiResponse?.data?.message || "Something went wrong.";
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      console.error("Error fetching shift templates", error);
      toast.error("Failed to fetch shift templates");
    } finally {
      // setLoading(false);
      setSelectedShift([]);
      setSelectedShiftIds([]);
    }
  };

  // Process CSV import using the same accept/reject logic as handleUpdateShift
  const processCSVImportGroup = async (csvItems) => {
    try {
      // All items in this group are for the same user + date
      const firstItem = csvItems[0];
      const formattedDate = firstItem.date; // YYYY-MM-DD from CSV
      const userIdForApi = firstItem.user_id_for_api;
      const staffId = firstItem.staff_id;

      if (!userIdForApi) {
        throw new Error(`No user_id mapping found for staff identifier ${staffId}`);
      }

      // Convert YYYY-MM-DD to DD-MM-YYYY format to match API response format
      const [year, month, day] = formattedDate.split('-');
      const apiDateFormat = `${day}-${month}-${year}`;
      console.log(`CSV Import: Converting date from ${formattedDate} to ${apiDateFormat} for API matching`);

      const headers = {
        Authorization: `Bearer ${authToken}`,
      };

      // Fetch existing shifts for this user/date to build slot map
      const payload = {
        premise_id: encryptData(selectedTopBarPremises?.value?.toString()),
        start_date: encryptData(formattedDate),
        end_date: encryptData(formattedDate),
      };

      const shiftDetailsResponse = await apiRequest(
        "/api/user/getSchedulerDetailsAllUser",
        "POST",
        payload,
        headers
      );

      // Find this user's shifts for this date
      let existingDateShifts = [];
      if (
        shiftDetailsResponse?.data?.status_code === 200 &&
        shiftDetailsResponse?.data?.data?.shift_details
      ) {
        const allShifts = shiftDetailsResponse?.data?.data?.shift_details;
        const staffIdToFind = typeof staffId === 'string' ? parseInt(staffId, 10) : staffId;
        const userShiftData = allShifts.find((u) => u.staff_id === staffIdToFind);

        if (userShiftData?.results) {
          const dateShift = userShiftData.results.find(
            (entry) => entry.date === apiDateFormat
          );
          existingDateShifts = dateShift?.slots || [];
        }
      }

      console.log(`CSV Import Group: Staff ${staffId} on ${formattedDate} - Existing shifts found:`, existingDateShifts.length, existingDateShifts);

      // Build slot map from existing shifts
      const slotMap = new Map();
      existingDateShifts.forEach((slot) => {
        slotMap.set(slot.user_shift_templates_id, slot);
      });

      // Get ALL selected shift template IDs from this group (all shifts for this date)
      const selectedShiftTemplateIds = csvItems.map(item => item.matches[0].id);
      console.log(`CSV Import Group: Group contains ${csvItems.length} shifts:`, selectedShiftTemplateIds);
      console.log(`CSV Import Group: SlotMap before processing (${slotMap.size} existing shifts):`, Array.from(slotMap.keys()));

      // Build update payload using same logic as handleUpdateShift
      const updatePayload = [];

      // Process each shift in the group
      for (const csvItem of csvItems) {
        const selectedShiftTemplateId = csvItem.matches[0].id;
        const matchedSlot = slotMap.get(selectedShiftTemplateId);

        if (matchedSlot) {
          // Template exists in slots => "accepted" (update existing)
          console.log(`CSV Import Group: Shift ${selectedShiftTemplateId} exists in current slots - marking as ACCEPTED`);
          updatePayload.push({
            user_shift_schedule_times_id: encryptData(
              matchedSlot.user_shift_schedule_times_id?.toString()
            ),
            user_shift_templates_id: encryptData(selectedShiftTemplateId?.toString()),
            shift_date: encryptData(formattedDate),
            staff_accepted_status: encryptData("accepted"),
          });
          // Remove from slotMap to track remaining (for "rejected")
          slotMap.delete(selectedShiftTemplateId);
        } else {
          // Template does not exist in slots => "new" mark as "accepted"
          console.log(`CSV Import Group: Shift ${selectedShiftTemplateId} is NEW - marking as ACCEPTED`);
          updatePayload.push({
            user_shift_schedule_times_id: encryptData(""),
            user_shift_templates_id: encryptData(selectedShiftTemplateId?.toString()),
            shift_date: encryptData(formattedDate),
            staff_accepted_status: encryptData("accepted"),
          });
        }
      }

      // Remaining slots in slotMap are "rejected" (same as handleUpdateShift)
      const remainingCount = slotMap.size;
      console.log(`CSV Import Group: Remaining shifts to reject: ${remainingCount}`, Array.from(slotMap.keys()));

      for (const slot of slotMap.values()) {
        console.log(`CSV Import Group: Marking shift ${slot.user_shift_templates_id} as REJECTED`);
        updatePayload.push({
          user_shift_schedule_times_id: encryptData(
            slot.user_shift_schedule_times_id?.toString()
          ),
          user_shift_templates_id: encryptData(
            slot.user_shift_templates_id?.toString()
          ),
          shift_date: encryptData(formattedDate),
          staff_accepted_status: encryptData("rejected"),
        });
      }

      console.log(`CSV Import Group: Final payload has ${updatePayload.length} entries (${csvItems.length} accepted + ${remainingCount} rejected)`);

      // Call acceptRejectShiftByUser API
      const updatePayload_for_API = {
        premise_id: encryptData(selectedTopBarPremises?.value?.toString()),
        staff_id: encryptData(staffId?.toString()),
        user_id: encryptData(userIdForApi?.toString()),
        arrayofacceptrejectshift: updatePayload,
      };

      console.log(`CSV Import Group: Sending to API:`, updatePayload_for_API);

      const apiResponse = await apiRequest(
        "/api/user/acceptRejectShiftByUser",
        "POST",
        updatePayload_for_API,
        headers
      );

      console.log(`CSV Import Group: API Response for staff ${staffId}:`, apiResponse?.data);

      if (apiResponse?.data?.status_code === 200) {
        return { ok: true, message: apiResponse.data.message || "Success" };
      } else {
        const errorMessage =
          apiResponse?.data?.message || "Import failed";
        return { ok: false, message: errorMessage };
      }
    } catch (error) {
      console.error("Error processing CSV import group:", error);
      return { ok: false, message: error.message || "Network error" };
    }
  };

  const fetchStaffNotInCalender = async (premise_id) => {
    // setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const apiResponse = await apiRequest(
        `/api/user/getStaffDetailsNotInSettings?premise_id=${encryptData(
          premise_id?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (
        apiResponse?.data?.status_code === 200 &&
        apiResponse?.data?.data?.staff_details
      ) {
        if (apiResponse?.data?.data?.staff_details?.length > 0) {
          const staffData = apiResponse?.data?.data?.staff_details;
          setStaffList(staffData);
        } else {
          setStaffList([]);
        }
      } else {
        const errorMessage =
          apiResponse?.data?.message || "Something went wrong.";
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      console.error("Error fetching shift templates", error);
      toast.error("Failed to fetch shift templates");
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    initialFetchShiftDetails(selectedTopBarPremises?.value);
  }, [startDate]);

  const [dateRange, setDateRange] = useState([
    {
      startDate: addDays(new Date(), 1), // Tomorrow
      endDate: endOfWeek(new Date(), { weekStartsOn: 0 }), // Saturday as last date of this week
      key: "selection",
    },
  ]);

  const [tempDateRange, setTempDateRange] = useState([...dateRange]);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [open, setOpen] = useState(false);
  const [createShiftOpen, setCreateShiftOpen] = useState(false);
  const [cloneShiftOpen, setCloneShiftOpen] = useState(false);
  const [cloneToDate, setCloneToDate] = useState(
    addDays(dateRange[0].endDate, 1)
  );
  const [staffList, setStaffList] = useState([]);
  const [assignedShifts, setAssignedShifts] = useState({});
  const [assignedCreateShifts, setAssignedCreateShifts] = useState({});
  const [searchStaff, setSearchStaff] = useState("");

  const handleShiftChange = (staffId, shiftId) => {
    setAssignedShifts((prev) => ({
      ...prev,
      [staffId]: { ...prev[staffId], shiftId },
    }));
  };

  const handleEditToggle = (staffId, canEdit) => {
    setAssignedShifts((prev) => ({
      ...prev,
      [staffId]: { ...prev[staffId], canEdit },
    }));
  };

  const addStaffShiftAPI = async (staffShiftData) => {
    setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };

      console.log("staffShiftData-->", staffShiftData);

      const payload = {
        ArrayofCreateShiftForStaff: staffShiftData,
      };

      const apiResponse = await apiRequest(
        "/api/user/addDefaultShiftForStaff",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        await fetchShiftDetails();
        toast.success(apiResponse?.data?.message, {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        const errorMessage =
          apiResponse?.data?.message || "Something went wrong.";
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      console.error("Error fetching shift templates", error);
      toast.error("Failed to fetch shift templates");
    } finally {
      setLoading(false);
      setSelectedShift([]);
      setSelectedShiftIds([]);
      setSelectedUser("");
      setSelectedStaffList([]);
      setAssignedShifts({});
      fetchStaffNotInCalender(selectedTopBarPremises?.value);
    }
  };

  const [actionType, setActionType] = useState("");
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmCreateShiftDialogOpen, setConfirmCreateShiftDialogOpen] =
    useState(false);
  const [confirmCloneShiftDialogOpen, setConfirmCloneShiftDialogOpen] =
    useState(false);
  const [pendingShiftData, setPendingShiftData] = useState([]); // To store data before confirm

  const [infoDialogOpen, setInfoDialogOpen] = useState(false);

  const handlePublishOrLock = (type) => {
    if (shiftDetails?.length === 0) {
      toast.info(
        "No staff have been assigned to the shift. Please add staff.",
        {
          position: "top-right",
          autoClose: 7000,
        }
      );
      return;
    }
    setActionType(type);
    if (type == "publish") {
      if (publishStatus == "true") {
        toast.info("Shifts are already published", {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        setConfirmDialogOpen(true);
      }
    } else {
      if (lockStatus == "true") {
        toast.info("Shifts are already locked", {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        setConfirmDialogOpen(true);
      }
    }
  };

  console.log("publishStatus--->", publishStatus);

  const publishOrLockShiftsAPI = async (type) => {
    setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };

      const startDate1 = startDate.format("YYYY-MM-DD");
      const endDate = moment(startDate).add(6, "days").format("YYYY-MM-DD");

      const payload = {
        ArrayOfstaff_id: allstaffIds,
        start_date: encryptData(startDate1?.toString()),
        end_date: encryptData(endDate?.toString()),
        type: encryptData(type?.toString()), //publish or lock
      };

      const apiResponse = await apiRequest(
        "/api/user/publishLockScheduledShift",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        await fetchShiftDetails();
        toast.success(apiResponse?.data?.message, {
          position: "top-right",
          autoClose: 2000,
        });
      } else {
        const errorMessage =
          apiResponse?.data?.message || "Something went wrong.";
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      console.error("Error fetching shift templates", error);
      toast.error("Failed to fetch shift templates");
    } finally {
      setLoading(false);
      setSelectedShift([]);
      setSelectedShiftIds([]);
      setSelectedUser("");
      setSelectedStaff("");
    }
  };

  const formatDateValue = (date) => {
    const day = date.getDate().toString().padStart(2, "0"); // Adds leading zero if day < 10
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Adds leading zero if month < 10
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const createDefaultShiftAPI = async (arrayOfStaffShiftDetails) => {
    setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };

      console.log("staffShiftData-->", arrayOfStaffShiftDetails);

      const payload = {
        start_date: encryptData(formatDateValue(dateRange[0].startDate)),
        end_date: encryptData(formatDateValue(dateRange[0].endDate)),
        arrayOfStaffShiftDetails: arrayOfStaffShiftDetails,
      };

      const apiResponse = await apiRequest(
        "/api/user/createDefaultShiftForStaff",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        AccessLog("Create Default Shifts");
        await fetchShiftDetails();
        toast.success(apiResponse?.data?.message, {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        const errorMessage =
          apiResponse?.data?.message || "Something went wrong.";
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      console.error("Error fetching shift templates", error);
      toast.error("Failed to fetch shift templates");
    } finally {
      setLoading(false);
      setSelectedAddShiftUsers([]);
      setOverrideShifts(false);
    }
  };

  const createCloneShiftAPI = async (arrayOfStaffShiftDetails) => {
    setLoading(true);
    // Example usage:
    const sourceStart = formatDateValue(dateRange[0].startDate);
    const sourceEnd = formatDateValue(dateRange[0].endDate);
    const cloneTo = formatDateValue(cloneToDate);

    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };

      const payload = {
        start_date: encryptData(sourceStart),
        end_date: encryptData(sourceEnd),
        clone_to: encryptData(cloneTo), // or plain cloneTo depending on backend
        users: selectedUserIds,
        premise_id: encryptData(selectedTopBarPremises?.value?.toString()),
      };

      const apiResponse = await apiRequest(
        "/api/user/cloneUserShifts",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        AccessLog("Clone Shifts");
        await fetchShiftDetails();
        toast.success(apiResponse?.data?.message, {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        const errorMessage =
          apiResponse?.data?.message || "Something went wrong.";
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      console.error("Error fetching shift templates", error);
      toast.error("Failed to fetch shift templates");
    } finally {
      setLoading(false);
      setSelectedAddShiftUsers([]);
      setOverrideShifts(false);
    }
  };

  useEffect(() => {
    if (staffList.length) {
      const initialShifts = {};
      staffList.forEach((staff) => {
        initialShifts[staff.staff_id] = {
          shiftId: workShiftTemplates[0]?.user_shift_templates_id || "",
          canEdit: false,
        };
      });
      setAssignedShifts(initialShifts);
    }
  }, [staffList, workShiftTemplates]);

  const handleCreateShiftChange = (staffId, shiftId) => {
    setAssignedCreateShifts((prev) => ({
      ...prev,
      [staffId]: { ...prev[staffId], shiftId },
    }));
  };

  console.log("assignedCreateShifts--->", assignedCreateShifts);
  const handleStaffCheckboxChange = (id) => {
    setSelectedAddStaff((prev) =>
      prev.includes(id) ? prev.filter((sid) => sid !== id) : [...prev, id]
    );
  };

  const handleStaffSelectAll = (checked) => {
    setSelectedAddStaff(checked ? staffList.map((s) => s.staff_id) : []);
  };

  const isAllSelected =
    staffList.length > 0 && selectedAddStaff.length === staffList.length;

  const handleSubmit = () => {
    const staffShiftData = selectedAddStaff.map((id) => ({
      staff_id: encryptData(id.toString()),
      default_template_id: encryptData(
        assignedShifts[id]?.shiftId?.toString() || ""
      ),
      can_edit: encryptData(assignedShifts[id]?.canEdit?.toString() || "false"),
      max_hours: encryptData("8"),
    }));

    console.log("Assigned Shifts:", staffShiftData);
    setOpen(false);
    addStaffShiftAPI(staffShiftData);
  };

  const filteredStaff = staffList.filter((staff) =>
    staff.user_name.toLowerCase().includes(searchStaff.toLowerCase())
  );

  console.log("staffList--->", staffList);

  // Simulating an API call to fetch work shift templates
  useEffect(() => {
    fetchShiftTemplates(selectedTopBarPremises?.value);
    fetchStaffNotInCalender(selectedTopBarPremises?.value);
    AccessLog("Staff Shifts");
  }, []);

  const [selectedAddShiftUsers, setSelectedAddShiftUsers] = useState([]);

  // ✅ Check if user is already selected
  const isUserSelected = (id) => {
    return selectedAddShiftUsers.some((user) => user.staff_id === id);
  };

  const [selectedUserIds, setSelectedUserIds] = useState([]);

  const handleUserCheck = (userObj, checked) => {
    setSelectedAddShiftUsers(
      (prev) =>
        checked
          ? [...prev, userObj] // ✅ Add full object
          : prev.filter((user) => user.staff_id !== userObj.staff_id) // ✅ Remove by ID
    );
    setSelectedUserIds(
      (prev) =>
        checked
          ? [...prev, userObj.staff_id] // Add staff_id
          : prev.filter((id) => id !== userObj.staff_id) // Remove staff_id
    );
  };

  console.log("selectedAddShiftUsers--->", selectedAddShiftUsers);

  // ✅ Select all users
  const handleSelectAll = (checked) => {
    console.log("shiftDetailsData--->", shiftDetails);
    if (checked) {
      setSelectedAddShiftUsers(shiftDetails); // Add all user objects
      setSelectedUserIds(shiftDetails.map((user) => user?.staff_id));
    } else {
      setSelectedAddShiftUsers([]); // Clear all
      setSelectedUserIds([]);
    }
  };

  console.log("selectedUserIds--->", selectedUserIds);

  useEffect(() => {
    const initialAssigned = {};
    selectedAddShiftUsers.forEach((staff) => {
      initialAssigned[staff.staff_id] = {
        shiftId: staff.default_template_id, // 👈 use default_template_id
      };
    });
    setAssignedCreateShifts(initialAssigned);
  }, [selectedAddShiftUsers]);

  // Create Shift

  const [overrideShifts, setOverrideShifts] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showCloneToPicker, setShowCloneToPicker] = useState(false);

  const handleCreateShift = () => {
    if (selectedAddShiftUsers.length === 0) {
      toast.info("Please select at least one staff member to create a shift.", {
        position: "top-right",
        autoClose: 4000,
      });
    } else {
      setCreateShiftOpen(true);
    }
  };

  const handleCloneShift = () => {
    if (selectedAddShiftUsers.length === 0) {
      toast.info("Please select at least one staff member to clone a shift.", {
        position: "top-right",
        autoClose: 4000,
      });
    } else {
      setCloneShiftOpen(true);
    }
  };

  // Apply selected range from temp to actual
  const handleApplyDatePicker = () => {
    console.log("tempDateRange--->", tempDateRange);
    setDateRange(tempDateRange);
    // Add this: set cloneToDate to one day after the selected endDate
    const selectedEndDate = new Date(tempDateRange[0].endDate);
    const newCloneToDate = addDays(selectedEndDate, 1);
    setCloneToDate(newCloneToDate);
    setShowDatePicker(false);
  };

  // Close popup without saving
  const handleCloseDatePicker = () => {
    setTempDateRange([...dateRange]);
    setShowDatePicker(false);
  };

  const handleCreateShiftSubmit = () => {
    if (selectedAddShiftUsers.length === 0) {
      toast.info("Please select at least one staff member to create a shift.", {
        position: "top-right",
        autoClose: 2000,
      });
      return;
    }

    const arrayOfStaffShiftDetails = selectedAddShiftUsers.map((staff) => {
      const assigned = assignedCreateShifts[staff.staff_id];

      return {
        staff_id: encryptData(staff.staff_id?.toString()),
        default_template_id:
          encryptData(assigned?.shiftId?.toString()) ||
          encryptData(staff.default_template_id?.toString()) ||
          encryptData(""),
        is_override: encryptData(overrideShifts?.toString()),
      };
    });

    // Store data temporarily and show confirmation
    setPendingShiftData(arrayOfStaffShiftDetails);
    setConfirmCreateShiftDialogOpen(true);
  };

  console.log("startDate--->", startDate);
  console.log("startDate1--->", dateRange);

  const formatDate = (date) => {
    const day = date.getDate().toString().padStart(2, "0"); // Adds leading zero if day < 10
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Adds leading zero if month < 10
    const year = date.getFullYear();
    const dateFormat =
      selectedTopBarPremises?.date_format === "d-m-Y"
        ? `${day}-${month}-${year}`
        : `${month}-${day}-${year}`;
    return dateFormat;
  };

  const today = new Date();

  const tomorrow = addDays(today, 1);

  const customStaticRanges = createStaticRanges([
    {
      label: "This Week",
      range: () => ({
        startDate: tomorrow,
        endDate: endOfWeek(tomorrow, { weekStartsOn: 1 }), // week ends on Sunday
      }),
    },
    {
      label: "This Month",
      range: () => ({
        startDate: tomorrow,
        endDate: endOfMonth(tomorrow),
      }),
    },
  ]);

  const handleAddStaffWithShift = () => {
    if (workShiftTemplates.length === 0) {
      toast.info(
        "No shifts have been defined. Please create a shift before assigning staff.",
        {
          position: "top-right",
          autoClose: 6000,
        }
      );
    } else {
      setOpen(true);
    }
  };

  console.log("staffListAPI--->", staffList);

  useEffect(() => {
    const today = moment();
    const start = moment(startDate);

    let newStartDate;

    if (start.isSame(today, "week")) {
      // If it's the current week, start from tomorrow
      newStartDate = moment().add(1, "day").toDate();
    } else {
      // Other weeks: use start of that week
      newStartDate = start.toDate();
    }

    const newEndDate = moment(startDate).endOf("week").toDate();

    setDateRange([
      {
        startDate: newStartDate,
        endDate: newEndDate,
        key: "selection",
      },
    ]);

    setTempDateRange([
      {
        startDate: newStartDate,
        endDate: newEndDate,
        key: "selection",
      },
    ]);
  }, [startDate]);

  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);

    // Initial check (in case the state is stale)
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const selectThisWeek = () => {
    const today = new Date();
    const start = new Date(today.setDate(today.getDate() - today.getDay()));
    const end = new Date(start);
    end.setDate(start.getDate() + 6);
    setTempDateRange([{ startDate: start, endDate: end, key: "selection" }]);
  };

  const selectThisMonth = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    setTempDateRange([{ startDate: start, endDate: end, key: "selection" }]);
  };

  const weekDates = getWeekDates(); // Array of moment objects for the week

  console.log("weekDates-->", weekDates);

  // Helper function to convert decimal hours to HH:MM
  const formatHours = (totalHours) => {
    const totalMinutes = Math.floor(totalHours * 60); // convert to minutes
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}:${minutes.toString().padStart(2, "0")}`;
  };

  // Initialize column totals
  const columnTotals = weekDates.reduce((acc, date) => {
    acc[date.format("DD-MM-YYYY")] = 0;
    return acc;
  }, {});

  let grandTotal = 0;

  useEffect(() => {
    setCloneToDate(addDays(dateRange[0].endDate, 1));
  }, [dateRange]);

  const handleCloneShiftSubmit = async () => {
    setConfirmCloneShiftDialogOpen(true);
  };

  const theme = useTheme();
  // const isMobileRes = useMediaQuery(theme.breakpoints.down("sm"));

  const responsiveGridStyle = {
    display: "grid",
    gridTemplateColumns: isMobile ? "1fr 1fr" : "120px 30px 1fr 1fr 80px",
    gap: isMobile ? 1 : 1.5,
    mb: 1.5,
    alignItems: "center",
    rowGap: isMobile ? 1.5 : 0,
  };

  // Styled box for dates and days
  const dateBoxStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #ccc",
    padding: "4px 8px",
    borderRadius: "4px",
    background: "#fff",
    fontSize: "0.9rem",
    minHeight: "32px",
    cursor: "pointer",
    width: "100%",
  };

  // Format date with weekday
  // const formatWithDay = (date) => {
  //   const d = new Date(date);
  //   return d.toLocaleDateString("en-GB", {
  //     weekday: "short", // Mon, Tue, etc.
  //     day: "2-digit",
  //     month: "2-digit",
  //     year: "numeric",
  //   });
  // };

  const formatWithDay = (date) => {
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    // Get day name (e.g., Monday)
    const dayName = date.toLocaleDateString("en-US", { weekday: "short" });

    // Premises-based date format
    const dateFormat =
      selectedTopBarPremises?.date_format === "d-m-Y"
        ? `${day}-${month}-${year}`
        : `${month}-${day}-${year}`;

    return `${dayName}, ${dateFormat}`;
  };

  // CSV Export / Import helpers
  const fileInputRef = useRef(null);

  const exportToCsv = (includeTimes = false, datesArg = null, dataArg = null) => {
    try {
      const dates = datesArg || getWeekDates();
      // Include User ID column between Staff ID and date columns
      const headers = ["Staff Name", "Staff ID", "User ID", ...dates.map((d) => `"${d.format("YYYY-MM-DD")}"`)];

      const source = dataArg || shiftDetails;

      const rows = source.map((user) => {
        const base = [user.user_name || "", user.staff_id || "", user.user_id || user.userId || ""];
        const rowDates = dates.map((date) => {
          const dateStr = date.format("DD-MM-YYYY");
          // For matching against stored data (which uses DD-MM-YYYY internally)
          const result = user.results?.find((r) => r.date === dateStr);
          if (!result) return "";
          const slots = result.slots || [];
          if (!slots.length) return result.note || "";
          // join multiple slots
          return slots
            .map((s) => {
              const start = s.start_time || s.start || s.startTime || "";
              const end = s.end_time || s.end || s.endTime || "";
              const name = s.shift_name || s.shift || s.name || "";
              const t = `${start}-${end}`;
              if (includeTimes) {
                return name ? `${name} (${t})` : t;
              }
              // only export shift name if available, otherwise fallback to time range
              return name || t;
            })
            .join(" | ");
        });
        return [...base, ...rowDates];
      });

      const csvContent = [headers, ...rows]
        .map((e) =>
          e
            .map((v) => "" + v) // ensure string
            .map((v) => v.replace(/"/g, '""'))
            .map((v) => `"${v}"`)
            .join(",")
        )
        .join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      // filename: if exporting a month range (datesArg provided), use YYYYMM
      const filename = datesArg ? `staff_shifts_${dates[0].format("YYYYMM")}.csv` : `staff_shifts_${dates[0].format("YYYYMMDD")}.csv`;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Export failed", err);
      toast.error("Failed to export CSV");
    }
  };

  const handleImportClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  // RFC4180-compatible CSV parser (handles quoted fields, commas/newlines inside quotes)
  const parseCsv = (text) => {
    const rows = [];
    let cur = "";
    let row = [];
    let inQuotes = false;
    for (let i = 0; i < text.length; i++) {
      const ch = text[i];
      const next = text[i + 1];
      if (ch === '"') {
        if (inQuotes && next === '"') {
          cur += '"'; // escaped quote
          i++; // skip next
        } else {
          inQuotes = !inQuotes; // toggle
        }
      } else if (ch === ',' && !inQuotes) {
        row.push(cur);
        cur = '';
      } else if ((ch === '\n' || ch === '\r') && !inQuotes) {
        // handle CRLF or LF
        if (ch === '\r' && next === '\n') {
          // consume \n as well
        }
        row.push(cur);
        rows.push(row.map((c) => c.trim()));
        row = [];
        cur = '';
        // skip potential LF after CR
        if (ch === '\r' && next === '\n') i++;
      } else {
        cur += ch;
      }
    }
    // push last field
    if (cur !== '' || row.length > 0) {
      row.push(cur);
      rows.push(row.map((c) => c.trim()));
    }
    return rows;
  };

  // Convert wide-format CSV rows to import items: [{ staff_name, staff_id, date, shift_name, matches, ambiguous, error }]
  const convertRowsToItems = (rows) => {
    if (!rows || rows.length < 2) return { items: [], error: 'CSV must have a header row and at least one data row', infoRows: 0, infoColumns: 0 };
    
    let infoRows = 0;
    let infoColumns = 0;
    
    let header = rows[0].map((h) => h.replace(/^"|"$/g, '').trim());
    
    // Filter out columns with 'info' header (case insensitive)
    const originalHeaderLength = header.length;
    header = header.filter((h) => !/^info$/i.test(h.trim()));
    infoColumns = originalHeaderLength - header.length;
    
    // Map original indices to new indices (accounting for removed columns)
    const columnIndexMap = {};
    let newIdx = 0;
    for (let oldIdx = 0; oldIdx < originalHeaderLength; oldIdx++) {
      if (!/^info$/i.test(rows[0][oldIdx].replace(/^"|"$/g, '').trim())) {
        columnIndexMap[oldIdx] = newIdx;
        newIdx++;
      }
    }
    
    // Filter rows based on column map
    const filteredRows = rows.map((row) => {
      const newRow = [];
      for (let oldIdx = 0; oldIdx < row.length; oldIdx++) {
        if (columnIndexMap.hasOwnProperty(oldIdx)) {
          newRow[columnIndexMap[oldIdx]] = row[oldIdx];
        }
      }
      return newRow;
    });
    
    // Expect first columns to be Staff Name, Staff ID, optionally User ID
    const h0 = header[0]?.toLowerCase();
    const h1 = header[1]?.toLowerCase();
    if (!h1 || (!h1.includes('staff') && !h1.includes('id'))) {
      return { items: [], error: 'Expected second column to be Staff ID', infoRows, infoColumns };
    }

    // Determine whether a User ID column exists as the third column
    let dateStartIndex = 2;
    const thirdHeader = header[2] || '';
    if (/user\s*_?id/i.test(thirdHeader) || /user\s+id/i.test(thirdHeader)) {
      dateStartIndex = 3;
    }

    // Remaining headers should be dates in YYYY-MM-DD
    const dateHeaders = header.slice(dateStartIndex);
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    const isDateHeader = dateHeaders.every((d) => dateRegex.test(d));
    if (!isDateHeader) {
      return { items: [], error: `Expected date columns in YYYY-MM-DD format starting from column ${dateStartIndex + 1}`, infoRows, infoColumns };
    }

    const items = [];
    for (let r = 1; r < filteredRows.length; r++) {
      const row = filteredRows[r];
      if (!row || row.length < 2) continue;
      const staffName = row[0] || '';
      const staffId = row[1] || '';
      
      // Check if first cell contains 'info' (case insensitive)
      if (/^info$/i.test(staffName.trim())) {
        infoRows++;
        continue;
      }
      
      const csvUserId = dateStartIndex === 3 ? (row[2] || '') : null;
      if (!staffId) {
        // skip rows without staff id
        continue;
      }
      for (let c = dateStartIndex; c < header.length; c++) {
        const cell = row[c] || '';
        const date = header[c];
        if (!cell || cell.trim() === '') continue; // empty cell => no shift
        
        // Split by | to support multiple shifts in one day
        const shiftEntries = cell.trim().split('|').map((s) => s.trim()).filter((s) => s.length > 0);
        
        for (const entry of shiftEntries) {
          // Parse shift name and optional (start-end) times
          // Format: "ShiftName (HH:MM-HH:MM)" or just "ShiftName"
          let shiftName = entry;
          let startTime = null;
          let endTime = null;
          const timeMatch = entry.match(/^(.+?)\s*\(([0-9:]+)-([0-9:]+)\)$/);
          if (timeMatch) {
            shiftName = timeMatch[1].trim();
            startTime = timeMatch[2].trim();
            endTime = timeMatch[3].trim();
          }

          // find matching templates
          const nameLower = shiftName.toLowerCase();
          let matches = workShiftTemplates.filter((t) => {
            const candidate = (t.shift_name || t.name || t.shift || '') + '';
            return candidate.toLowerCase() === nameLower;
          });

          // If start/end times provided, filter matches further
          if (startTime && endTime && matches.length > 0) {
            matches = matches.filter((t) => {
              const tStart = (t.start_time || t.start || t.startTime || '') + '';
              const tEnd = (t.end_time || t.end || t.endTime || '') + '';
              return tStart === startTime && tEnd === endTime;
            });
          }

          const item = {
            staff_name: staffName,
            staff_id: staffId,
            date,
            shift_name: shiftName,
            start_time: startTime,
            end_time: endTime,
            parsed_entry: entry,
            matches: matches.map((m) => ({ id: m.user_shift_templates_id, label: m.shift_name || m.name || m.shift })),
            ambiguous: matches.length > 1,
            error: matches.length === 0 ? `No matching shift template found for "${entry}"` : null,
            // map CSV staff_id to backend user_id using staffList available in component scope
            user_id_for_api: null,
          };

          // Map user id for API and validate strictly against `shiftDetails` (no fallback)
          try {
            const normalizeName = (v) => {
              if (v == null) return '';
              let s = v.toString();
              // remove surrounding straight or smart quotes
              s = s.replace(/^["'\u2018\u2019\u201C\u201D]+|["'\u2018\u2019\u201C\u201D]+$/g, '');
              // collapse multiple whitespace and trim
              s = s.replace(/\s+/g, ' ').trim();
              return s.toLowerCase();
            };

            const nameLower = normalizeName(staffName);
            const matchedRecord = shiftDetails.find((s) =>
              normalizeName(s.user_name || s.name || '') === nameLower
            ) || null;

            if (!matchedRecord) {
              item.error = item.error || `Staff name "${staffName}" not found in schedule table`;
            } else {
              // Verify staff_id matches the record
              if (matchedRecord.staff_id != null && String(matchedRecord.staff_id) !== String(staffId)) {
                item.error = item.error || `Staff ID mismatch for "${staffName}": CSV has ${staffId}, table has ${matchedRecord.staff_id}`;
              }

              // If CSV provides a user id column, ensure it matches the record's user id
              if (csvUserId) {
                if (matchedRecord.user_id != null && String(matchedRecord.user_id) !== String(csvUserId)) {
                  item.error = item.error || `User ID mismatch for "${staffName}": CSV has ${csvUserId}, table has ${matchedRecord.user_id}`;
                } else {
                  item.user_id_for_api = csvUserId;
                }
              } else {
                // No CSV user id column — use record's user id when available
                item.user_id_for_api = matchedRecord.user_id ?? matchedRecord.userId ?? item.user_id_for_api;
              }
            }
          } catch (mapErr) {
            console.warn('Error mapping staff/user id during CSV import', mapErr);
            item.error = item.error || `Error mapping staff identifier "${staffId}"`;
          }

          // Disallow past dates: mark item as error if date is before today
          try {
            if (date && moment(date, 'YYYY-MM-DD').isBefore(moment(), 'day')) {
              item.error = `Date ${date} is in the past; only today or future dates are allowed`;
            }
          } catch (dateErr) {
            // if date parsing fails, leave existing errors intact
            console.warn('Error validating CSV date', dateErr);
          }

          items.push(item);
        }
      }
    }
    return { items, infoRows, infoColumns };
  };

  const handleImportFile = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const text = evt.target.result;
        const rows = parseCsv(text);
        const { items, error, infoRows, infoColumns } = convertRowsToItems(rows);
        if (error) {
          toast.error(error);
          return;
        }
        // store parsed items, info counts, and open preview
        setParsedItems(items);
        // reset previous import progress/results when loading a new file
        setImportProgress({ total: 0, success: 0, failed: 0 });
        setImportResults([]);
        setImportInProgress(false);
        setInfoRowsCount(infoRows || 0);
        setInfoColumnsCount(infoColumns || 0);
        setPreviewOpen(true);
      } catch (err) {
        console.error('CSV parse failed', err);
        toast.error('Failed to parse CSV');
      }
    };
    reader.readAsText(file);
    // reset input so same file can be re-uploaded
    e.target.value = null;
  };

  // Fetch shift details for a custom date range (YYYY-MM-DD)
  const fetchShiftDetailsRange = async (startDateStr, endDateStr) => {
    try {
      const headers = { Authorization: `Bearer ${authToken}` };
      const payload = {
        premise_id: encryptData(selectedTopBarPremises?.value?.toString()),
        start_date: encryptData(startDateStr?.toString()),
        end_date: encryptData(endDateStr?.toString()),
      };
      const apiResponse = await apiRequest(
        "/api/user/getSchedulerDetailsAllUser",
        "POST",
        payload,
        headers
      );

      if (
        apiResponse?.data?.status_code === 200 &&
        apiResponse?.data?.data?.shift_details
      ) {
        return apiResponse.data.data.shift_details;
      }
      throw new Error(apiResponse?.data?.message || "No data returned");
    } catch (err) {
      console.error("Error fetching month shift details", err);
      throw err;
    }
  };

  // Calculate days between two dates
  const getDaysCount = (start, end) => {
    const s = new Date(start);
    const e = new Date(end);
    return Math.floor((e - s) / (1000 * 60 * 60 * 24)) + 1;
  };

  const getTargetEndDate = (cloneStartDate) => {
    const days = getDaysCount(dateRange[0].startDate, dateRange[0].endDate);
    const endDate = new Date(cloneStartDate);
    endDate.setDate(endDate.getDate() + (days - 1));
    return endDate;
  };

  return (
    <div className="dashboard-layout">
      <Sidebar selectedPremise={selectedPremise} />
      <div className="main-content dashboardMain">
        <Topbar onPremiseSelect={handlePremiseSelect} />
        <ToastContainer />
        {/* {pageLoading && <Loader />} */}
        <div className="content staffShiftMainDiv">
          {/* <div className="contentHeader d-flex align-items-center gap-3 pb-3">
            <div className="contentDiv">
              <Breadcrumb className="contentTitle">
                <Breadcrumb.Item active>Work Shift</Breadcrumb.Item>
                <Breadcrumb.Item active>Define Shifts</Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </div> */}
          <div className="row justify-content-center">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <Box
                className="staffShiftMainBox"
                sx={{ background: "#f4f6f8", minHeight: "100vh" }}
              >
                {/* Header Section */}

                {/* Date Navigation */}
                <Box
                  className="date-nav"
                  sx={{
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 2,
                    flexDirection: {
                      xs: "column", // stack on mobile
                      sm: "row", // row on tablet and up
                    },
                    gap: 1,
                  }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    width={{ xs: "100%", sm: "300px" }}
                    justifyContent="center"
                  >
                    <Tooltip title="Add staff to the shift">
                      <Button
                        variant="outlined"
                        size="small"
                        sx={{ fontSize: "12px", padding: "2px 4px" }}
                        onClick={() => handleAddStaffWithShift()}
                        disabled={selectedAddShiftUsers.length !== 0}
                      >
                        Add Staff
                      </Button>
                    </Tooltip>
                    <Tooltip title={"Create default shift"}>
                      <Button
                        variant="outlined"
                        size="small"
                        sx={{ fontSize: "12px", padding: "2px 4px" }}
                        onClick={() => handleCreateShift()}
                        disabled={!startDate.isSameOrAfter(moment(), "week")}
                      >
                        Create Shift
                      </Button>
                    </Tooltip>
                    <Tooltip title={"Clone shift"}>
                      <Button
                        variant="outlined"
                        size="small"
                        sx={{ fontSize: "12px", padding: "2px 4px" }}
                        onClick={() => handleCloneShift()}
                        disabled={!startDate.isSameOrAfter(moment(), "week")}
                      >
                        Clone Shift
                      </Button>
                    </Tooltip>
                  </Box>

                  {/* Center Group */}
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    position={{ xs: "relative", sm: "absolute" }}
                    left={{ sm: "55%" }}
                    sx={{
                      transform: { sm: "translateX(-50%)" },
                      mt: { xs: 1, sm: 0 },
                    }}
                  >
                    <Button
                      onClick={handlePrevWeek}
                      variant="outlined"
                      className="nav-button leftDateArrow"
                    >
                      <i className="fas fa-chevron-left" />
                    </Button>

                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      className="DateRangeInfo"
                      sx={{ mx: 2 }}
                    >
                      {startDate.format("MMM DD, YYYY")} -{" "}
                      {moment(startDate).add(6, "days").format("MMM DD, YYYY")}
                    </Typography>

                    <Button
                      onClick={handleNextWeek}
                      variant="outlined"
                      className="nav-button leftDateArrow"
                    >
                      <i className="fas fa-chevron-right" />
                    </Button>
                  </Box>

                  {/* Right Side: Publish & Lock */}
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    width={{ xs: "100%", sm: "33%" }}
                    justifyContent={{ xs: "center", sm: "flex-end" }}
                    mt={{ xs: 1, sm: 0 }}
                  >
                    {/* Upload / Download */}
                    <input
                      type="file"
                      accept=".csv,text/csv"
                      ref={fileInputRef}
                      onChange={handleImportFile}
                      style={{ display: "none" }}
                    />
                    <Tooltip title="Upload CSV">
                      <Button variant="outlined" onClick={handleImportClick}>
                        <i className="fas fa-upload" />
                      </Button>
                    </Tooltip>
                    <Tooltip title="Download CSV">
                      <Button
                        variant="outlined"
                        onClick={() => setDownloadDialogOpen(true)}
                      >
                        <i className="fas fa-download" />
                      </Button>
                    </Tooltip>
                    {publishStatus != "hide" && (
                      <Tooltip title="Publish Shifts">
                        <Button
                          variant="outlined"
                          onClick={() => handlePublishOrLock("publish")}
                          disabled={selectedAddShiftUsers.length !== 0}
                        >
                          <i className="fas fa-paper-plane" />
                        </Button>
                      </Tooltip>
                    )}
                    {lockStatus != "hide" && (
                      <Tooltip title="Lock Shifts">
                        <Button
                          variant="outlined"
                          onClick={() => handlePublishOrLock("lock")}
                          disabled={selectedAddShiftUsers.length !== 0}
                        >
                          <i className="fas fa-lock" />
                        </Button>
                      </Tooltip>
                    )}
                  </Box>
                </Box>

                {/* CSV Import Preview / Confirm Dialog */}
                <Dialog
                  open={previewOpen}
                  onClose={() => {
                    if (!importInProgress) setPreviewOpen(false);
                  }}
                  fullWidth
                  maxWidth="lg"
                >
                  <DialogTitle>Preview CSV Import</DialogTitle>
                  <DialogContent>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      The table below shows parsed rows. Rows marked with warnings will be skipped unless corrected.
                    </Typography>
                    {(infoRowsCount > 0 || infoColumnsCount > 0) && (
                      <Box sx={{ mb: 2, p: 1.5, bgcolor: 'info.light', borderRadius: 1, border: '1px solid', borderColor: 'info.main' }}>
                        <Typography variant="body2" color="info.dark">
                          <strong>Marked as info during import:</strong>
                          {infoColumnsCount > 0 && ` ${infoColumnsCount} column(s) with 'info' header;`}
                          {infoRowsCount > 0 && ` ${infoRowsCount} row(s) with 'info' in first cell.`}
                        </Typography>
                      </Box>
                    )}
                    {/* Summary counts: Errors / OK / Ambiguous (styled) */}
                    <Box sx={{ display: 'flex', gap: 2, mb: 1, alignItems: 'center' }}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', px: 1.25, py: 0.5, borderRadius: 1, bgcolor: 'rgba(255,0,0,0.04)' }}>
                        <Typography sx={{ fontSize: '1.1rem', fontWeight: 700, color: 'error.main' }}>{parsedItems ? parsedItems.filter((it) => it.error).length : 0}</Typography>
                        <Typography variant="caption" sx={{ fontWeight: 700 }}>Errors</Typography>
                      </Box>

                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', px: 1.25, py: 0.5, borderRadius: 1, bgcolor: 'rgba(0,128,0,0.04)' }}>
                        <Typography sx={{ fontSize: '1.1rem', fontWeight: 700, color: 'success.main' }}>{parsedItems ? parsedItems.filter((it) => !it.error && !it.ambiguous).length : 0}</Typography>
                        <Typography variant="caption" sx={{ fontWeight: 700 }}>OK</Typography>
                      </Box>

                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', px: 1.25, py: 0.5, borderRadius: 1, bgcolor: 'rgba(255,165,0,0.04)' }}>
                        <Typography sx={{ fontSize: '1.1rem', fontWeight: 700, color: 'warning.main' }}>{parsedItems ? parsedItems.filter((it) => it.ambiguous && !it.error).length : 0}</Typography>
                        <Typography variant="caption" sx={{ fontWeight: 700 }}>Ambiguous</Typography>
                      </Box>
                    </Box>
                    <Box sx={{ maxHeight: 400, overflow: 'auto' }}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Staff ID</TableCell>
                            <TableCell>Staff Name</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Shift Entry</TableCell>
                            <TableCell>Shift Name</TableCell>
                            <TableCell>Start-End</TableCell>
                            <TableCell>Template Match</TableCell>
                            <TableCell>Status</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {parsedItems.map((it, idx) => (
                            <TableRow key={idx}>
                              <TableCell>{it.staff_id}</TableCell>
                              <TableCell>{it.staff_name}</TableCell>
                              <TableCell>{it.date}</TableCell>
                              <TableCell><code>{it.parsed_entry}</code></TableCell>
                              <TableCell>{it.shift_name}</TableCell>
                              <TableCell>{it.start_time && it.end_time ? `${it.start_time}-${it.end_time}` : '—'}</TableCell>
                              <TableCell>
                                {it.matches.length === 0 && <em>—</em>}
                                {it.matches.length === 1 && <>{it.matches[0].label} (id:{it.matches[0].id})</>}
                                {it.matches.length > 1 && (
                                  <>
                                    Multiple matches ({it.matches.map((m) => m.id).join(', ')})
                                  </>
                                )}
                              </TableCell>
                              <TableCell>
                                {it.error ? (
                                  <Typography color="error" variant="caption">{it.error}</Typography>
                                ) : it.ambiguous ? (
                                  <Typography color="warning.main" variant="caption">Multiple templates found</Typography>
                                ) : (
                                  <Typography color="success.main" variant="caption">OK</Typography>
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Box>
                    <Box sx={{ mt: 2 }}>
                      <Typography variant="caption">Progress: {importProgress.success} succeeded, {importProgress.failed} failed, {importProgress.total} total</Typography>
                      {importInProgress && <LinearProgress variant="determinate" value={(importProgress.success + importProgress.failed) / Math.max(1, importProgress.total) * 100} sx={{ mt: 1 }} />}
                    </Box>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => setPreviewOpen(false)} disabled={importInProgress}>Cancel</Button>
                    <Button
                      onClick={async () => {
                        // Block entire import if any parsed row contains a past date
                        try {
                          const pastRows = parsedItems.filter((it) => it.date && moment(it.date, 'YYYY-MM-DD').isBefore(moment(), 'day'));
                          if (pastRows.length > 0) {
                            toast.error(`Import contains ${pastRows.length} row(s) with past dates. Only today's and future dates are allowed.`);
                            return;
                          }
                        } catch (chkErr) {
                          console.warn('Error checking parsed item dates before import', chkErr);
                        }

                        // Confirm import: process parsedItems sequentially using handleUpdateShift logic
                        const toImport = parsedItems.filter((it) => !it.error && !it.ambiguous);
                        if (toImport.length === 0) {
                          toast.info('No valid rows to import (resolve errors/ambiguities first)');
                          return;
                        }

                        // Group items by user_id_for_api + date to handle multiple shifts on same day
                        const groupedByUserDate = {};
                        for (const item of toImport) {
                          const key = `${item.user_id_for_api}|${item.date}`;
                          if (!groupedByUserDate[key]) {
                            groupedByUserDate[key] = [];
                          }
                          groupedByUserDate[key].push(item);
                        }

                        console.log(`CSV Import: Grouped items by user+date:`, groupedByUserDate);

                        setImportInProgress(true);
                        const totalGroups = Object.keys(groupedByUserDate).length;
                        setImportProgress({ total: totalGroups, success: 0, failed: 0 });
                        const results = [];

                        // Process each user+date group as a single transaction
                        for (const key of Object.keys(groupedByUserDate)) {
                          const itemsForGroup = groupedByUserDate[key];
                          console.log(`CSV Import: Processing group ${key} with ${itemsForGroup.length} shifts:`, itemsForGroup.map(it => it.shift_name));
                          
                          const result = await processCSVImportGroup(itemsForGroup);
                          
                          if (result.ok) {
                            setImportProgress((p) => ({ ...p, success: p.success + 1 }));
                            results.push(...itemsForGroup.map(item => ({ item, ok: true, message: result.message })));
                          } else {
                            setImportProgress((p) => ({ ...p, failed: p.failed + 1 }));
                            console.error(`Import failed for group ${key}:`, result.message);
                            results.push(...itemsForGroup.map(item => ({ item, ok: false, message: result.message })));
                          }
                        }

                        setImportResults(results);
                        setImportInProgress(false);
                        // refresh calendar data
                        await fetchShiftDetails();
                        toast.success(`Import finished: ${results.filter(r=>r.ok).length} succeeded, ${results.filter(r=>!r.ok).length} failed`);
                        setPreviewOpen(false);
                      }}
                      variant="contained"
                      disabled={importInProgress}
                    >
                      Confirm Import
                    </Button>
                  </DialogActions>
                </Dialog>

                {/* Download Dialog */}
                <Dialog
                  open={downloadDialogOpen}
                  onClose={() => setDownloadDialogOpen(false)}
                >
                  <DialogTitle>Download shifts for month</DialogTitle>
                  <DialogContent>
                    <FormControl fullWidth sx={{ mt: 1 }}>
                      <InputLabel id="download-month-label">Month</InputLabel>
                      <Select
                        labelId="download-month-label"
                        value={downloadMonth}
                        label="Month"
                        onChange={(e) => setDownloadMonth(Number(e.target.value))}
                      >
                        {Array.from({ length: 12 }).map((_, i) => (
                          <MenuItem key={i} value={i}>
                            {moment().month(i).format("MMMM")}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl fullWidth sx={{ mt: 2 }}>
                      <InputLabel id="download-year-label">Year</InputLabel>
                      <Select
                        labelId="download-year-label"
                        value={downloadYear}
                        label="Year"
                        onChange={(e) => setDownloadYear(Number(e.target.value))}
                      >
                        {Array.from({ length: 5 }).map((_, idx) => {
                          const y = downloadToday.year() - 2 + idx;
                          return (
                            <MenuItem key={y} value={y}>
                              {y}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={exportIncludeTimes}
                          onChange={(e) => setExportIncludeTimes(e.target.checked)}
                        />
                      }
                      label="Include start/end times"
                      sx={{ mt: 2 }}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => setDownloadDialogOpen(false)}>
                      Cancel
                    </Button>
                    <Button
                      onClick={async () => {
                        try {
                          setPageLoading(true);
                          const startMoment = moment([downloadYear, downloadMonth, 1]);
                          const days = startMoment.daysInMonth();
                          const dates = Array.from({ length: days }).map((_, i) =>
                            moment(startMoment).add(i, "days")
                          );

                          const startStr = startMoment.format("YYYY-MM-DD");
                          const endStr = moment(startMoment)
                            .add(days - 1, "days")
                            .format("YYYY-MM-DD");

                          // fetch month data from backend and export
                          const fetched = await fetchShiftDetailsRange(startStr, endStr);
                          exportToCsv(exportIncludeTimes, dates, fetched);
                          toast.success("CSV downloaded");
                          setDownloadDialogOpen(false);
                        } catch (err) {
                          console.error("Month export failed", err);
                          toast.error("Failed to fetch month data for export");
                        } finally {
                          setPageLoading(false);
                        }
                      }}
                    >
                      Download
                    </Button>
                  </DialogActions>
                </Dialog>

                {/* Shift Table */}
                <Card elevation={4}>
                  <CardContent className="shift-card">
                    {/* Table Header */}
                    <Box
                      className="scrollable-plan-section"
                      sx={{ overflowX: "auto", width: "100%" }}
                    >
                      <Box
                        sx={{
                          display: "inline-block", // Let it expand based on its children
                          minWidth: "100%", // Ensures full width used but allows scroll
                        }}
                      >
                        <Grid
                          container
                          spacing={1}
                          className="shift-table-header"
                          sx={{
                            position: "sticky",
                            top: 0,
                            backgroundColor: "#fff",
                            zIndex: 10,
                          }}
                        >
                          <Grid
                            item
                            xs={2}
                            display="flex"
                            alignItems="center"
                            className="StaffMainHeader"
                          >
                            <Checkbox
                              checked={
                                selectedAddShiftUsers.length ===
                                  shiftDetails.length && shiftDetails.length > 0
                              }
                              onChange={(e) =>
                                handleSelectAll(e.target.checked)
                              }
                              sx={{
                                marginTop: "-12px",
                                padding: "3px 10px 0px 0px",
                              }}
                              className="staffCheckBox"
                            />

                            <h4
                              className="shiftTableHeader staffNameHeader"
                              style={{ margin: 0, marginTop: "-9px" }}
                            >
                              STAFF NAME
                            </h4>
                          </Grid>

                          {getWeekDates().map((date) => (
                            <Grid
                              item
                              xs
                              key={date.format("YYYY-MM-DD")}
                              sx={{ textAlign: "center" }}
                            >
                              <h4 className="shiftTableHeader">
                                {/* {date.format("ddd D")} */}
                                {date.format("ddd").toUpperCase()}{" "}
                                {date.format("D")}
                              </h4>
                            </Grid>
                          ))}

                          <Grid
                            item
                            display="flex"
                            alignItems="center"
                            sx={{
                              minWidth: "65px",
                              textAlign: "center",
                              fontWeight: "bold",
                              fontSize: "16px",
                              color: "#0e2241",
                              width: "65px",
                            }}
                          >
                            <h4 className="shiftTableHeader totalHeader">
                              TOTAL
                            </h4>
                          </Grid>
                        </Grid>

                        {/* Employee Rows */}

                        {loading ? (
                          <>
                            {[...Array(10)].map((_, i) => (
                              <Box key={i} sx={{ marginBottom: 2 }}>
                                <Shimmer width="100%" height="40px" />
                              </Box>
                            ))}
                          </>
                        ) : (
                          <Box
                            className="shift-scroll-container"
                            sx={{
                              maxHeight: "calc(100vh - 250px)",
                              overflowY: "auto",
                              paddingRight: "5px",
                              "&::-webkit-scrollbar": {
                                width: "6px", // scrollbar width
                              },
                              "&::-webkit-scrollbar-track": {
                                background: "transparent", // optional
                              },
                              "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#b0b0b0",
                                borderRadius: "10px",
                              },
                              "&::-webkit-scrollbar-thumb:hover": {
                                backgroundColor: "#888",
                              },
                            }}
                          >
                            {shiftDetails.map((user, index) => {
                              let totalHoursRow = 0; // Track per-user total

                              return (
                                <Grid
                                  container
                                  spacing={1}
                                  alignItems="center"
                                  key={index}
                                  className="shift-user-row"
                                  sx={{}}
                                >
                                  {/* Employee Info */}
                                  <Grid
                                    item
                                    xs={2}
                                    sx={{ paddingTop: "10px" }}
                                    className="employeeMainDiv"
                                  >
                                    <Box className="employee-info">
                                      <Checkbox
                                        sx={{ padding: "0px" }}
                                        checked={selectedAddShiftUsers.some(
                                          (selectedUser) =>
                                            selectedUser.staff_id ===
                                            user.staff_id
                                        )} // ✅ Check using staff_id inside selectedAddShiftUsers
                                        onChange={(e) =>
                                          handleUserCheck(
                                            user,
                                            e.target.checked
                                          )
                                        } // ✅ Pass full user object
                                      />

                                      <Avatar
                                        className="employee-avatar"
                                        src={
                                          user?.user_profile || userDummyImage
                                        }
                                        onError={(e) => {
                                          e.preventDefault();
                                          e.target.onerror = null; // Prevent looping
                                          e.target.removeAttribute("src"); // Remove broken src
                                          e.target.setAttribute(
                                            "src",
                                            userDummyImage
                                          ); // Set fallback
                                        }}
                                      >
                                        {user?.name?.charAt(0).toUpperCase()}
                                      </Avatar>

                                      <Box>
                                        <Typography
                                          variant="subtitle2"
                                          sx={{
                                            fontWeight: 600,
                                            color: "#0e2241",
                                            wordBreak: "break-word", // wrap at word boundaries
                                          }}
                                        >
                                          {user.user_name}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  </Grid>

                                  {/* Shift Cells */}
                                  {getWeekDates().map((date) => {
                                    const dateStr = date.format("DD-MM-YYYY");
                                    const results = user.results.find(
                                      (detail) => detail.date === dateStr
                                    );
                                    const slots = results ? results.slots : [];
                                    const notes = results ? results.note : "";
                                    console.log("slotsData--->", slots);
                                    const filteredSlots = slots?.filter(
                                      (shift) => shift.day_off !== "true"
                                    );
                                    // Calculate total hours for this cell
                                    let cellHours = 0;
                                    filteredSlots?.forEach((shift) => {
                                      const start = moment(
                                        shift.start,
                                        "hh:mma"
                                      );
                                      const end = moment(shift.end, "hh:mma");
                                      const duration = end.diff(
                                        start,
                                        "hours",
                                        true
                                      ); // decimal hours
                                      cellHours += duration;
                                    });

                                    // Add to row total and column total
                                    totalHoursRow += cellHours;
                                    columnTotals[dateStr] += cellHours;
                                    grandTotal += cellHours;

                                    return (
                                      <Grid
                                        item
                                        xs
                                        key={dateStr}
                                        className="shift-cell"
                                      >
                                        <Box className="shift-cell-box">
                                          {slots.length > 0 ? (
                                            slots.map((shift, i) =>
                                              // <Tooltip title="Click to edit the shift">
                                              //   <Box
                                              //     onClick={() =>
                                              //       handleEditShift(user, dateStr)
                                              //     }
                                              //     key={i}
                                              //     className="shift-block"
                                              //     sx={{
                                              //       position: "relative",
                                              //       backgroundColor: shift.color,
                                              //       padding: "4px",
                                              //       borderRadius: 2,
                                              //       marginBottom: 1,
                                              //       color: "#fff",
                                              //       fontWeight: 600,
                                              //       fontSize: "14px",
                                              //       boxShadow:
                                              //         "0 2px 6px rgba(0,0,0,0.15)",
                                              //       backgroundImage:
                                              //         shift.status !== "locked"
                                              //           ? `repeating-linear-gradient(
                                              //           145deg,
                                              //           ${shift.color},
                                              //           ${shift.color} 15px,
                                              //           rgba(0, 0, 0, 0.4) 8px,
                                              //           rgba(0, 0, 0, 0.4) 16px
                                              //         )`
                                              //           : "none",
                                              //     }}
                                              //   >
                                              //     {shift.start} - {shift.end}
                                              //   </Box>
                                              // </Tooltip>

                                              moment(
                                                dateStr,
                                                "DD-MM-YYYY"
                                              ).isBefore(moment(), "day") ? (
                                                // Past date: show Box without Tooltip and onClick
                                                <Box
                                                  key={i}
                                                  className="shift-block"
                                                  sx={{
                                                    position: "relative",
                                                    backgroundColor:
                                                      shift.color,
                                                    padding: "3px",
                                                    borderRadius: 2,
                                                    marginBottom: 1,
                                                    color: "#fff",
                                                    fontWeight: 600,
                                                    fontSize: "14px",
                                                    boxShadow:
                                                      "0 2px 6px rgba(0,0,0,0.15)",
                                                    backgroundImage:
                                                      shift.status !== "locked"
                                                        ? `repeating-linear-gradient(
                                                          145deg,
                                                          ${shift.color},
                                                          ${shift.color} 15px,
                                                          rgba(0, 0, 0, 0.4) 8px,
                                                          rgba(0, 0, 0, 0.4) 16px
                                                        )`
                                                        : "none",
                                                  }}
                                                >
                                                  {shift.start} - {shift.end}
                                                </Box>
                                              ) : (
                                                // Future or today: show Tooltip and enable onClick
                                                <Tooltip title="Click to edit the shift">
                                                  <Box
                                                    onClick={() =>
                                                      handleEditShift(
                                                        user,
                                                        dateStr
                                                      )
                                                    }
                                                    key={i}
                                                    className="shift-block"
                                                    sx={{
                                                      position: "relative",
                                                      backgroundColor:
                                                        shift.color,
                                                      padding: "3px",
                                                      borderRadius: 2,
                                                      marginBottom: 1,
                                                      color: "#fff",
                                                      fontWeight: 600,
                                                      fontSize: "14px",
                                                      boxShadow:
                                                        "0 2px 6px rgba(0,0,0,0.15)",
                                                      backgroundImage:
                                                        shift.status !==
                                                        "locked"
                                                          ? `repeating-linear-gradient(
                                                            145deg,
                                                            ${shift.color},
                                                            ${shift.color} 15px,
                                                            rgba(0, 0, 0, 0.4) 8px,
                                                            rgba(0, 0, 0, 0.4) 16px
                                                          )`
                                                          : "none",
                                                    }}
                                                  >
                                                    {shift.start} - {shift.end}
                                                  </Box>
                                                </Tooltip>
                                              )
                                            )
                                          ) : moment(
                                              dateStr,
                                              "DD-MM-YYYY"
                                            ).isBefore(moment(), "day") ? (
                                            <Box
                                              className="shift-block noShiftDiv"
                                              sx={{
                                                backgroundColor: "#acacacab",
                                                padding: "3px",
                                                borderRadius: 2,
                                                marginBottom: 1,
                                                color: "#fff",
                                                fontWeight: 600,
                                                fontSize: "14px",
                                                boxShadow:
                                                  "0 2px 6px rgba(0,0,0,0.15)",
                                              }}
                                            >
                                              {notes}
                                            </Box>
                                          ) : null}

                                          {
                                            moment(
                                              dateStr,
                                              "DD-MM-YYYY"
                                            ).isSameOrAfter(moment(), "day") &&
                                              (slots.length === 0 ? (
                                                <Tooltip title="Add Shift">
                                                  <IconButton
                                                    size="small"
                                                    onClick={() =>
                                                      handleAddShift(
                                                        user,
                                                        dateStr
                                                      )
                                                    }
                                                    sx={{
                                                      backgroundColor:
                                                        "#e0e0e0",
                                                      "&:hover": {
                                                        backgroundColor:
                                                          "#cfcfcf",
                                                      },
                                                      borderRadius: "50%",
                                                      padding: "6px",
                                                      color: "#1976d2",
                                                    }}
                                                  >
                                                    <i className="fas fa-plus addShiftIconBtn" />
                                                  </IconButton>
                                                </Tooltip>
                                              ) : null)
                                            // <Tooltip title="Edit Shift">
                                            //   <IconButton
                                            //     size="small"
                                            //     onClick={() =>
                                            //       handleEditShift(user, dateStr)
                                            //     }
                                            //     sx={{
                                            //       backgroundColor: "#e0e0e0",
                                            //       "&:hover": {
                                            //         backgroundColor: "#cfcfcf",
                                            //       },
                                            //       borderRadius: "50%",
                                            //       padding: "6px",
                                            //       color: "#1976d2c2",
                                            //       marginTop: "4px",
                                            //     }}
                                            //   >
                                            //     <i className="fas fa-edit editShiftIconBtn" />
                                            //   </IconButton>
                                            // </Tooltip>
                                          }
                                        </Box>
                                      </Grid>
                                    );
                                  })}
                                  <Grid
                                    item
                                    sx={{
                                      minWidth: "60px",
                                      textAlign: "center",
                                      fontWeight: "bold",
                                      fontSize: "16px",
                                      color: "#0e2241",
                                      paddingTop: "0px !important",
                                    }}
                                    className="totalHoursDiv"
                                  >
                                    {formatHours(totalHoursRow)}
                                  </Grid>
                                </Grid>
                              );
                            })}

                            {/* Footer Totals Row */}
                            <Grid
                              container
                              spacing={1}
                              alignItems="center"
                              className="shift-footer-row"
                              sx={{
                                mt: 1,
                                borderTop: "2px solid #d0d0d0",
                                backgroundColor: "#f7f9fc",
                                position: "sticky", // remove if you want it to scroll away
                                bottom: 0,
                                zIndex: 5,
                              }}
                            >
                              {/* Footer label cell aligns under STAFF NAME column */}
                              <Grid
                                item
                                xs={2}
                                sx={{
                                  minWidth: "60px",
                                  textAlign: "center",
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                  color: "#0e2241",
                                }}
                                className="shift-footer-label"
                              >
                                <h4
                                  className="shiftTableHeader shiftFooterTitle"
                                  sx={{
                                    marginBottom: "0px !important",
                                    display: "flex",
                                    justifyContent: "start",
                                    marginTop: "7px",
                                  }}
                                >
                                  TOTAL
                                </h4>
                              </Grid>

                              {/* Per-date totals */}
                              {getWeekDates().map((date) => {
                                const dateStr = date.format("DD-MM-YYYY");
                                return (
                                  <Grid
                                    item
                                    xs
                                    key={`col-total-${dateStr}`}
                                    sx={{ textAlign: "center" }}
                                    className="shift-footer-date-total totalHoursDiv"
                                  >
                                    <strong>
                                      {formatHours(columnTotals[dateStr])}
                                    </strong>
                                  </Grid>
                                );
                              })}

                              {/* Grand total cell */}
                              <Grid
                                item
                                sx={{
                                  minWidth: "60px",
                                  textAlign: "center",
                                  fontWeight: "bold",
                                  color: "#0e2241",
                                }}
                                className="shift-footer-grand-total"
                              ></Grid>
                            </Grid>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Box>

              <Dialog
                open={addShiftOpen}
                onClose={() => setAddShiftOpen(false)}
                fullWidth={false}
                maxWidth={false}
                PaperProps={{
                  sx: {
                    width: "600px", // Change to "200px" if needed
                    borderRadius: 2,
                  },
                }}
              >
                <DialogTitle
                  sx={{
                    background: "#2d64bc",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "1.25rem",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    padding: "16px 24px",
                  }}
                >
                  <i className="fas fa-clock" style={{ fontSize: 18 }}></i>
                  <span style={{ fontSize: 18, paddingTop: "3px" }}>
                    Select Work Shift
                  </span>
                </DialogTitle>

                <DialogContent
                  sx={{
                    maxHeight: "300px",
                    overflowY: "auto",
                    paddingBottom: 2,
                    zIndex: "auto", // optional
                  }}
                >
                  <FormControl fullWidth margin="dense">
                    <Select
                      labelId="shift-label"
                      multiple
                      value={selectedShiftIds}
                      open={isDropdownOpen}
                      onOpen={() => setIsDropdownOpen(true)}
                      onClose={() => setIsDropdownOpen(false)}
                      onChange={(e) => setSelectedShiftIds(e.target.value)}
                      renderValue={(selectedIds) => {
                        const rows = [];
                        for (let i = 0; i < selectedIds.length; i += 2) {
                          rows.push(selectedIds.slice(i, i + 2));
                        }

                        return (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 0.5,
                            }}
                          >
                            {rows.map((row, idx) => (
                              <Box key={idx} sx={{ display: "flex", gap: 0.5 }}>
                                {row.map((id) => {
                                  const shift = workShiftTemplates.find(
                                    (s) => s.user_shift_templates_id === id
                                  );
                                  return (
                                    <Chip
                                      key={id}
                                      label={`${shift.shift_name} - ${shift.start_time} - ${shift.end_time}`}
                                      sx={{ fontSize: "14px" }}
                                    />
                                  );
                                })}
                              </Box>
                            ))}
                          </Box>
                        );
                      }}
                      size="small"
                      MenuProps={{
                        disablePortal: true, // ✅ this is the key
                        PaperProps: {
                          style: {
                            maxHeight: 188,
                            zIndex: 1200, // optional, but can help
                          },
                        },
                      }}
                    >
                      {workShiftTemplates.map((shift) => (
                        <MenuItem
                          key={shift.user_shift_templates_id}
                          value={shift.user_shift_templates_id}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Checkbox
                            checked={selectedShiftIds.includes(
                              shift.user_shift_templates_id
                            )}
                          />
                          <ListItemText
                            primary={`${shift.shift_name} - ${shift.start_time} - ${shift.end_time}`}
                          />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </DialogContent>

                <DialogActions
                  sx={{
                    padding: "16px 24px",
                    position: "sticky",
                    bottom: 0,
                    background: "#fff",
                    borderTop: "1px solid #ccc",
                    ...(isDropdownOpen && { marginTop: "175px" }),
                    zIndex: 1501,
                  }}
                >
                  <Button
                    onClick={() => {
                      setAddShiftOpen(false);
                      setSelectedShift([]);
                      setSelectedShiftIds([]);
                    }}
                    color="inherit"
                    variant="outlined"
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleSaveShift}
                    disabled={selectedShiftIds.length === 0}
                    variant="contained"
                  >
                    Save
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={editShiftOpen}
                onClose={() => setEditShiftOpen(false)}
                fullWidth
                maxWidth={false}
                PaperProps={{
                  sx: {
                    width: "600px", // or "200px"
                  },
                }}
              >
                <DialogTitle
                  sx={{
                    background: "#2d64bc",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "1.25rem",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    padding: "16px 24px",
                  }}
                >
                  <i className="fas fa-clock" style={{ fontSize: 18 }}></i>
                  <span style={{ fontSize: 18, paddingTop: "3px" }}>
                    Select Work Shift
                  </span>
                </DialogTitle>

                <DialogContent
                  sx={{
                    maxHeight: "300px",
                    overflowY: "auto",
                    paddingBottom: 2,
                    zIndex: "auto", // optional
                  }}
                >
                  <FormControl fullWidth margin="dense">
                    <Select
                      labelId="shift-label"
                      multiple
                      value={selectedShiftIds}
                      open={isDropdownOpen}
                      onOpen={() => setIsDropdownOpen(true)}
                      onClose={() => setIsDropdownOpen(false)}
                      onChange={(e) => setSelectedShiftIds(e.target.value)}
                      renderValue={(selectedIds) => {
                        const rows = [];
                        for (let i = 0; i < selectedIds.length; i += 2) {
                          rows.push(selectedIds.slice(i, i + 2));
                        }

                        return (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 0.5,
                            }}
                          >
                            {rows.map((row, rowIndex) => (
                              <Box
                                key={rowIndex}
                                sx={{ display: "flex", gap: 0.5 }}
                              >
                                {row.map((id) => {
                                  const shift = workShiftTemplates.find(
                                    (s) => s.user_shift_templates_id === id
                                  );
                                  return (
                                    <Chip
                                      key={id}
                                      label={`${shift.shift_name} - ${shift.start_time} - ${shift.end_time}`}
                                      sx={{ fontSize: "14px" }}
                                    />
                                  );
                                })}
                              </Box>
                            ))}
                          </Box>
                        );
                      }}
                      size="small"
                      MenuProps={{
                        disablePortal: true, // ✅ this is the key
                        PaperProps: {
                          style: {
                            maxHeight: 188,
                            zIndex: 1200, // optional, but can help
                          },
                        },
                      }}
                    >
                      {workShiftTemplates.map((shift) => (
                        <MenuItem
                          key={shift.user_shift_templates_id}
                          value={shift.user_shift_templates_id}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Checkbox
                            checked={selectedShiftIds.includes(
                              shift.user_shift_templates_id
                            )}
                          />
                          <ListItemText
                            primary={`${shift.shift_name} - ${shift.start_time} - ${shift.end_time}`}
                          />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </DialogContent>

                <DialogActions
                  sx={{
                    padding: "16px 24px",
                    position: "sticky",
                    bottom: 0,
                    background: "#fff",
                    borderTop: "1px solid #ccc",
                    ...(isDropdownOpen && { marginTop: "175px" }),
                    zIndex: 1501,
                  }}
                >
                  <Button
                    onClick={() => {
                      setEditShiftOpen(false);
                      setSelectedShift([]);
                      setSelectedShiftIds([]);
                    }}
                    color="inherit"
                    variant="outlined"
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => {
                      handleUpdateShift(); // your update logic
                      setIsDropdownOpen(false); // ✅ manually close dropdown
                      setEditShiftOpen(false); // ✅ close the dialog if needed
                    }}
                    variant="contained"
                  >
                    Update
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={confirmDialogOpen}
                onClose={() => setConfirmDialogOpen(false)}
              >
                <DialogTitle
                  sx={{
                    backgroundColor: "#1976d2",
                    color: "#fff",
                    padding: "10px 24px",
                    fontSize: "1.1rem",
                  }}
                >
                  {actionType === "publish"
                    ? `Confirm Shifts Publication`
                    : `Confirm Shifts Lock`}
                </DialogTitle>
                <DialogContent dividers>
                  <Typography variant="body2" color="textSecondary">
                    {actionType === "publish"
                      ? `Please confirm if you would like to publish the shifts for this week.
                        Review all shift details carefully before proceeding.`
                      : `Please confirm if you would like to lock the shifts for this week.
                      Once locked, staff members will no longer be able to edit their shifts for this period.`}
                  </Typography>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setConfirmDialogOpen(false)}>
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      publishOrLockShiftsAPI(actionType);
                      setConfirmDialogOpen(false);
                    }}
                  >
                    Confirm
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={confirmCreateShiftDialogOpen}
                onClose={() => setConfirmCreateShiftDialogOpen(false)}
              >
                <DialogTitle
                  sx={{
                    backgroundColor: "#1976d2",
                    color: "#fff",
                    padding: "10px 24px",
                    fontSize: "1.1rem",
                  }}
                >
                  Confirm Shifts Creation
                </DialogTitle>
                <DialogContent dividers>
                  {/* <Typography variant="body1" sx={{ mb: 1 }}>
                    Are you sure you want to create the shift?
                  </Typography> */}
                  <Typography variant="body2" color="textSecondary">
                    Please confirm if you would like to create the shifts.
                    Review the override option, date range, and shift details
                    carefully. This action cannot be undone once confirmed.
                  </Typography>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => setConfirmCreateShiftDialogOpen(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      createDefaultShiftAPI(pendingShiftData); // 👈 Use stored data
                      setConfirmCreateShiftDialogOpen(false);
                      setCreateShiftOpen(false); // close shift dialog too
                    }}
                  >
                    Confirm
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={confirmCloneShiftDialogOpen}
                onClose={() => setConfirmCloneShiftDialogOpen(false)}
              >
                <DialogTitle
                  sx={{
                    backgroundColor: "#1976d2",
                    color: "#fff",
                    padding: "10px 24px",
                    fontSize: "1.1rem",
                  }}
                >
                  Confirm Shifts Cloning
                </DialogTitle>
                <DialogContent dividers>
                  {/* <Typography variant="body1" sx={{ mb: 1 }}>
                    Are you sure you want to create the shift?
                  </Typography> */}
                  <Typography variant="body2" color="textSecondary">
                    Please confirm if you’d like to proceed with cloning the
                    shifts. Ensure the source and destination date ranges are
                    selected correctly
                  </Typography>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setConfirmCloneShiftDialogOpen(false)}>
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      createCloneShiftAPI(); // 👈 Use stored data
                      setConfirmCloneShiftDialogOpen(false);
                      setCloneShiftOpen(false); // close shift dialog too
                      setSelectedUserIds([]);
                    }}
                  >
                    Confirm
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={infoDialogOpen}
                onClose={() => setInfoDialogOpen(false)}
              >
                <DialogTitle
                  sx={{
                    backgroundColor: "#1976d2",
                    color: "#fff",
                    padding: "10px 24px",
                    fontSize: "1.1rem",
                  }}
                >
                  Information
                </DialogTitle>
                <DialogContent dividers>
                  Shifts are already {actionType}ed.
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setInfoDialogOpen(false)} autoFocus>
                    OK
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={open}
                onClose={() => setOpen(false)}
                maxWidth="md"
                fullWidth
              >
                <DialogTitle
                  sx={{
                    fontWeight: "bold",
                    bgcolor: "#2d64bc",
                    color: "white",
                  }}
                >
                  Add Shift for Staff
                </DialogTitle>

                <DialogContent dividers sx={{ bgcolor: "#fafafa" }}>
                  <Box sx={{ mb: 2, marginLeft: "28px", fontWeight: 600 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isAllSelected}
                          onChange={(e) =>
                            handleStaffSelectAll(e.target.checked)
                          }
                        />
                      }
                      label="Select All Staff"
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontWeight: 600,
                        },
                      }}
                    />
                  </Box>
                  <Box sx={{ maxHeight: 400, overflowY: "auto", pr: 1 }}>
                    {staffList.map((staff) => (
                      <Paper
                        key={staff.staff_id}
                        elevation={2}
                        sx={{
                          p: 2,
                          mb: 2,
                          borderRadius: 2,
                          backgroundColor: "#fff",
                        }}
                      >
                        <Grid container spacing={2} alignItems="center">
                          <Grid item xs={1}>
                            <Checkbox
                              className="staffSelectCheckBox"
                              checked={selectedAddStaff.includes(
                                staff.staff_id
                              )}
                              sx={{
                                mt: { xs: 0 }, // 'mt' is margin-top
                              }}
                              onChange={() =>
                                handleStaffCheckboxChange(staff.staff_id)
                              }
                            />
                          </Grid>

                          <Grid
                            item
                            xs={11}
                            container
                            spacing={2}
                            alignItems="center"
                          >
                            <Grid item xs={12} sm={3}>
                              <Typography
                                variant="body1"
                                fontWeight="600"
                                className="shiftStaffName"
                                sx={{ color: "#0e2241", fontSize: "1rem" }}
                              >
                                {staff.user_name}
                              </Typography>
                            </Grid>

                            <Grid item xs={12} sm={5}>
                              <FormControl fullWidth>
                                <InputLabel sx={{ fontSize: "1rem" }}>
                                  Shift
                                </InputLabel>
                                <Select
                                  value={
                                    assignedShifts[staff.staff_id]?.shiftId ||
                                    ""
                                  }
                                  onChange={(e) =>
                                    handleShiftChange(
                                      staff.staff_id,
                                      e.target.value
                                    )
                                  }
                                  label="Shift"
                                  MenuProps={{
                                    PaperProps: {
                                      style: { maxHeight: 120 },
                                    },
                                  }}
                                >
                                  {workShiftTemplates.map((shift) => (
                                    <MenuItem
                                      key={shift.user_shift_templates_id}
                                      value={shift.user_shift_templates_id}
                                    >
                                      {shift.shift_name} ({shift.start_time} -{" "}
                                      {shift.end_time})
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>

                            <Grid
                              item
                              xs={12}
                              sm={4}
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "20px",
                              }}
                            >
                              <InputLabel>Can Edit Shifts?</InputLabel>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={
                                      assignedShifts[staff.staff_id]?.canEdit ||
                                      false
                                    }
                                    onChange={(e) =>
                                      handleEditToggle(
                                        staff.staff_id,
                                        e.target.checked
                                      )
                                    }
                                  />
                                }
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Paper>
                    ))}
                  </Box>
                </DialogContent>

                <DialogActions sx={{ p: 2, bgcolor: "#f5f5f5" }}>
                  <Button
                    onClick={() => {
                      setOpen(false);
                      setSelectedAddStaff([]);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={selectedAddStaff.length === 0}
                  >
                    Assign
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={createShiftOpen}
                onClose={() => setCreateShiftOpen(false)}
                maxWidth="md"
                fullWidth
              >
                <DialogTitle
                  sx={{
                    fontWeight: "bold",
                    bgcolor: "#2d64bc",
                    color: "white",
                  }}
                >
                  Create Shifts for Staff
                </DialogTitle>

                <DialogContent dividers sx={{ bgcolor: "#fafafa" }}>
                  {/* Override Switch & Date Range */}
                  <Box
                    display="flex"
                    flexDirection={isMobile ? "column" : "row"}
                    justifyContent="space-between"
                    alignItems={isMobile ? "flex-start" : "center"}
                    sx={{ px: 3, pb: 2, gap: 2 }}
                  >
                    {/* Override Existing Shifts */}
                    <FormControlLabel
                      control={
                        <Switch
                          checked={overrideShifts}
                          onChange={(e) => setOverrideShifts(e.target.checked)}
                        />
                      }
                      label="Override Existing Shifts"
                      sx={{ fontWeight: 600 }}
                    />

                    {/* Date Range */}
                    <Box>
                      <Tooltip title="Choose Date Range">
                        <Typography
                          onClick={() => setShowDatePicker(!showDatePicker)}
                          sx={{
                            cursor: "pointer",
                            color: "#0e2241",
                            fontSize: "1rem",
                            fontWeight: 550,
                          }}
                        >
                          {formatDate(dateRange[0].startDate)} -{" "}
                          {formatDate(dateRange[0].endDate)}{" "}
                          <span className="dateIcon">
                            <i className="fa-solid fa-calendar-days"></i>
                          </span>
                        </Typography>
                      </Tooltip>

                      {showDatePicker && (
                        <div
                          className="modal fade show"
                          id="dateRangeModal"
                          tabIndex="-1"
                          aria-labelledby="dateRangeModalLabel"
                          aria-hidden="false"
                          role="dialog"
                          style={{
                            display: "block",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                          }}
                        >
                          <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content dateRangeModal">
                              <div className="modal-header">
                                <h5
                                  className="modal-title"
                                  id="dateRangeModalLabel"
                                >
                                  Choose Date Range
                                </h5>
                                <button
                                  type="button"
                                  className="btn-close"
                                  onClick={handleCloseDatePicker}
                                  aria-label="Close"
                                ></button>
                              </div>
                              <div className="modal-body">
                                {/* Show only on mobile */}
                                <div className="mobile-quick-select d-block d-md-none mb-3">
                                  <button
                                    className="btn btn-outline-primary btn-sm me-2 mb-2"
                                    onClick={selectThisWeek}
                                  >
                                    This Week
                                  </button>
                                  <button
                                    className="btn btn-outline-primary btn-sm me-2 mb-2"
                                    onClick={selectThisMonth}
                                  >
                                    This Month
                                  </button>
                                </div>

                                {/* Calendar visible on all screens */}
                                <div className="calendar-wrapper">
                                  <DateRangePicker
                                    onChange={
                                      (item) =>
                                        setTempDateRange([item.selection]) // Store temporary selection
                                    }
                                    showSelectionPreview={true}
                                    moveRangeOnFirstSelection={false}
                                    months={2}
                                    ranges={tempDateRange} // Use temporary state for preview
                                    // minDate={addDays(new Date(), 1)}
                                    inputRanges={[]}
                                    // staticRanges={customStaticRanges}
                                    direction={
                                      isMobile ? "vertical" : "horizontal"
                                    }
                                    staticRanges={
                                      isMobile ? [] : customStaticRanges
                                    }
                                  />
                                </div>
                              </div>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-success deleteYesBtn"
                                  onClick={handleApplyDatePicker}
                                >
                                  Apply
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-danger deleteNoBtn"
                                  onClick={handleCloseDatePicker}
                                >
                                  Cancel
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </Box>
                  </Box>

                  {/* Select All Checkbox */}
                  <Box sx={{ mb: 2, marginLeft: "28px", fontWeight: 600 }}>
                    {/* <FormControlLabel
                      control={
                        <Checkbox
                          checked={isAllSelected}
                          onChange={(e) =>
                            handleStaffSelectAll(e.target.checked)
                          }
                        />
                      }
                      label="Select All Staff sasa"
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontWeight: 600,
                        },
                      }}
                    /> */}
                  </Box>

                  {/* Staff List with Shift Select */}
                  <Box sx={{ maxHeight: 400, overflowY: "auto", pr: 1 }}>
                    {selectedAddShiftUsers.map((staff) => (
                      <Paper
                        key={staff.staff_id}
                        elevation={2}
                        sx={{
                          p: 2,
                          mb: 2,
                          borderRadius: 2,
                          backgroundColor: "#fff",
                        }}
                      >
                        <Grid container spacing={2} alignItems="center">
                          <Grid item xs={12} sm={4}>
                            <Typography
                              variant="body1"
                              fontWeight="600"
                              sx={{ color: "#0e2241", fontSize: "1rem" }}
                            >
                              {staff.user_name}
                            </Typography>
                          </Grid>

                          {/* Spacer */}
                          <Grid
                            item
                            xs={0}
                            sm={1}
                            display={{ xs: "none", sm: "block" }}
                          />

                          <Grid item xs={12} sm={7}>
                            <FormControl fullWidth>
                              <InputLabel sx={{ fontSize: "1rem" }}>
                                Shift
                              </InputLabel>
                              <Select
                                value={
                                  assignedCreateShifts[staff.staff_id]
                                    ?.shiftId || ""
                                }
                                onChange={(e) =>
                                  handleCreateShiftChange(
                                    staff.staff_id,
                                    e.target.value
                                  )
                                }
                                label="Shift"
                                MenuProps={{
                                  PaperProps: {
                                    style: { maxHeight: 120 },
                                  },
                                }}
                              >
                                {workShiftTemplates.map((shift) => (
                                  <MenuItem
                                    key={shift.user_shift_templates_id}
                                    value={shift.user_shift_templates_id}
                                  >
                                    {shift.shift_name} ({shift.start_time} -{" "}
                                    {shift.end_time})
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </Paper>
                    ))}
                  </Box>
                </DialogContent>

                {/* Actions */}
                <DialogActions sx={{ p: 2, bgcolor: "#f5f5f5" }}>
                  <Button onClick={() => setCreateShiftOpen(false)}>
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleCreateShiftSubmit}
                    disabled={selectedAddShiftUsers.length === 0}
                  >
                    Create Shift
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={cloneShiftOpen}
                onClose={() => setCloneShiftOpen(false)}
                sx={{ maxWidth: "650px !important", margin: "auto" }}
                fullWidth
              >
                <DialogTitle
                  sx={{
                    fontWeight: "bold",
                    bgcolor: "#2d64bc",
                    color: "white",
                  }}
                >
                  Clone Shifts
                </DialogTitle>

                <DialogContent className="cloneShiftDialogContentDiv" dividers sx={{ bgcolor: "#fafafa", p: 3 }}>
                  <Typography variant="body2" sx={{ mb: 2 }}>
                    You can use the options below to <b>clone</b> a series of
                    existing shifts.
                  </Typography>

                  {/* Source Range */}
                  <Box sx={{ mb: 3 }}>
                    <Typography sx={{ fontWeight: 550, mb: 1 }}>
                      Source Range:
                    </Typography>

                    {/* Header Row */}
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "40px 1fr 1fr 80px",
                        gap: 2,
                        mb: 1,
                        fontWeight: 600,
                        color: "#333",
                        textAlign: "center",
                        alignItems: "center",
                      }}
                      className="sourceRangeMainDiv"
                    >
                      <Box></Box>
                      <Typography className="dateLabel">Start Date</Typography>
                      <Typography className="dateLabel">End Date</Typography>
                      <Typography className="dateLabel">Days</Typography>
                    </Box>

                    {/* Values Row */}
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "40px 1fr 1fr 80px",
                        gap: 2,
                        alignItems: "center",
                      }}
                      className="sourceRangeMainDiv"
                    >
                      {/* Calendar Icon */}
                      <Box sx={{ textAlign: "center" }}>
                        <i
                          className="fa-solid fa-calendar-days"
                          style={{ color: "#2d64bc", cursor: "pointer" }}
                          onClick={() => setShowDatePicker(true)}
                        ></i>
                      </Box>

                      {/* Start Date */}
                      <Box
                        sx={dateBoxStyle}
                        onClick={() => setShowDatePicker(true)}
                        className="dateValueDiv"
                      >
                        {formatWithDay(dateRange[0].startDate)}
                      </Box>

                      {/* End Date */}
                      <Box
                        sx={dateBoxStyle}
                        onClick={() => setShowDatePicker(true)}
                                 className="dateValueDiv"
                      >
                        {formatWithDay(dateRange[0].endDate)}
                      </Box>

                      {/* Days */}
                      <Box
                        sx={dateBoxStyle}
                        textAlign="center"
                        className="totalDaysDiv dateValueDiv"
                      >
                        {getDaysCount(
                          dateRange[0].startDate,
                          dateRange[0].endDate
                        )}
                      </Box>
                    </Box>
                  </Box>

                  {/* Target Range */}
                  <Box>
                    <Typography sx={{ fontWeight: 550, mb: 1 }}>
                      Target Range:
                    </Typography>

                    {/* Header Row */}
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "40px 1fr 1fr 80px",
                        gap: 2,
                        mb: 1,
                        fontWeight: 600,
                        color: "#333",
                        textAlign: "center",
                        alignItems: "center",
                      }}
                      className="sourceRangeMainDiv"
                    >
                      <Box></Box>
                      <Typography className="dateLabel">Start Date</Typography>
                      <Typography className="dateLabel">End Date</Typography>
                      <Typography className="dateLabel">Days</Typography>
                    </Box>

                    {/* Values Row */}
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "40px 1fr 1fr 80px",
                        gap: 2,
                        alignItems: "center",
                      }}
                      className="sourceRangeMainDiv"
                    >
                      {/* Calendar Icon */}
                      <Box sx={{ textAlign: "center" }}>
                        <i
                          className="fa-solid fa-calendar-days"
                          style={{ color: "#2d64bc", cursor: "pointer" }}
                          onClick={() => setShowCloneToPicker(true)}
                        ></i>
                      </Box>

                      {/* Start Date */}
                      <Box
                        sx={dateBoxStyle}
                        onClick={() => setShowCloneToPicker(true)}
                                                         className="dateValueDiv"
                      >
                        {formatWithDay(cloneToDate)}
                      </Box>

                      {/* End Date */}
                      <Box sx={dateBoxStyle} className="totalDaysDiv dateValueDiv">
                        {formatWithDay(getTargetEndDate(cloneToDate))}
                      </Box>

                      {/* Days */}
                      <Box
                        sx={dateBoxStyle}
                        textAlign="center"
                        className="totalDaysDiv dateValueDiv"
                      >
                        {getDaysCount(
                          dateRange[0].startDate,
                          dateRange[0].endDate
                        )}
                      </Box>
                    </Box>
                  </Box>
                </DialogContent>

                {showDatePicker && (
                  <div
                    className="modal fade show"
                    id="dateRangeModal"
                    tabIndex="-1"
                    aria-labelledby="dateRangeModalLabel"
                    aria-hidden="false"
                    role="dialog"
                    style={{
                      display: "block",
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                    }}
                  >
                    <div className="modal-dialog modal-dialog-centered">
                      <div className="modal-content dateRangeModal">
                        <div className="modal-header">
                          <h5 className="modal-title" id="dateRangeModalLabel">
                            Choose Date Range
                          </h5>
                          <button
                            type="button"
                            className="btn-close"
                            onClick={handleCloseDatePicker}
                            aria-label="Close"
                          ></button>
                        </div>
                        <div className="modal-body">
                          {/* Show only on mobile */}
                          {/* <div className="mobile-quick-select d-block d-md-none mb-3">
                                  <button
                                    className="btn btn-outline-primary btn-sm me-2 mb-2"
                                    onClick={selectThisWeek}
                                  >
                                    This Week
                                  </button>
                                  <button
                                    className="btn btn-outline-primary btn-sm me-2 mb-2"
                                    onClick={selectThisMonth}
                                  >
                                    This Month
                                  </button>
                                </div> */}

                          {/* Calendar visible on all screens */}
                          <div className="calendar-wrapper">
                            <DateRangePicker
                              onChange={
                                (item) => setTempDateRange([item.selection]) // Store temporary selection
                              }
                              showSelectionPreview={true}
                              moveRangeOnFirstSelection={false}
                              months={2}
                              ranges={tempDateRange} // Use temporary state for preview
                              // minDate={addDays(new Date(), 1)}
                              inputRanges={[]}
                              // staticRanges={customStaticRanges}
                              direction={isMobile ? "vertical" : "horizontal"}
                              staticRanges={isMobile ? [] : customStaticRanges}
                            />
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-success deleteYesBtn"
                            onClick={handleApplyDatePicker}
                          >
                            Apply
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger deleteNoBtn"
                            onClick={handleCloseDatePicker}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {showCloneToPicker && (
                  <div
                    className="modal fade show"
                    style={{
                      display: "block",
                      backgroundColor: "rgba(0,0,0,0.5)",
                    }}
                  >
                    <div className="modal-dialog modal-dialog-centered">
                      <div className="modal-content dateModal">
                        <div className="modal-header">
                          <h5 className="modal-title">Select Date</h5>
                          <button
                            type="button"
                            className="btn-close"
                            onClick={() => setShowCloneToPicker(false)}
                          ></button>
                        </div>
                        <div className="modal-body">
                          <Calendar
                            date={cloneToDate}
                            onChange={(date) => {
                              setCloneToDate(date);
                              setShowCloneToPicker(false);
                            }}
                            minDate={addDays(new Date(), 1)}
                          />
                        </div>
                        {/* <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-success"
                                  onClick={() => setShowCloneToPicker(false)}
                                >
                                  Apply
                                </button>
                              </div> */}
                      </div>
                    </div>
                  </div>
                )}

                <DialogActions sx={{ p: 2, bgcolor: "#f5f5f5" }}>
                  <Button onClick={() => setCloneShiftOpen(false)}>
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleCloneShiftSubmit}
                    disabled={selectedAddShiftUsers.length === 0}
                  >
                    Clone Shift
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffShift;
